var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _g5, _path18, _path19, _path20, _path21, _g6, _path22, _path23, _path24, _path25, _g7, _path26, _path27, _path28, _path29, _g8, _path30, _path31, _path32, _path33, _g9, _path34, _path35, _path36, _path37, _g10, _path38, _path39, _path40, _path41, _path42, _path43, _g11, _path44, _path45, _path46, _path47, _g12, _path48, _path49, _path50, _path51, _g13, _path52, _path53, _path54, _path55, _g14, _path56, _path57, _path58, _path59, _path60, _g15, _path61, _path62, _path63, _path64, _g16, _path65, _path66, _path67, _path68, _path69, _g17, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g18, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g19, _path87, _path88, _path89, _path90, _g20, _path91, _path92, _path93, _path94, _g21, _path95, _path96, _path97, _path98, _path99, _g22, _path100, _path101, _path102, _path103, _path104, _g23, _path105, _path106, _path107, _path108, _g24, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g25, _path117, _path118, _path119, _path120, _g26, _path121, _g27, _path122, _path123, _path124, _path125, _g28, _path126, _path127, _path128, _path129, _g29, _path130, _path131, _path132, _path133, _g30, _path134, _path135, _path136, _path137, _g31, _path138, _path139, _path140, _path141, _g32, _path142, _path143, _path144, _path145, _g33, _path146, _path147, _path148, _path149, _g34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceEffective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 44,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5061 19.71H61.9149V64.0979H18.5061V19.71Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 44,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0528 57.6225C20.8034 53.3458 18.6526 48.1511 18.6131 42.0518C18.5736 35.9538 20.6581 30.7311 24.8526 26.4008C29.0458 22.0699 34.115 19.8783 40.0893 19.8394C46.0636 19.8011 51.1748 21.9277 55.4241 26.2051C56.0418 26.8292 56.6156 27.4819 57.1453 28.1347C59.0175 30.7496 60.3798 33.5704 61.2467 36.6143C61.2761 36.7022 61.2914 36.7896 61.306 36.8775C61.3213 36.9355 61.3366 36.9936 61.3507 37.0516C61.3507 37.0516 61.3507 37.0516 61.3513 37.0669C61.3666 37.1536 61.3819 37.2409 61.3972 37.3142C61.4112 37.3289 61.4112 37.3429 61.4112 37.3575C61.5476 38.0275 61.6394 38.7128 61.7166 39.3981V39.4127C61.7325 39.4867 61.7325 39.5734 61.7331 39.6454C61.8746 41.1772 61.8695 42.739 61.7197 44.3595C61.7338 44.3735 61.7338 44.3735 61.7197 44.3881C61.7338 44.4028 61.7338 44.4028 61.7197 44.4175C61.707 44.6508 61.6789 44.8847 61.6515 45.1034C61.4004 47.0457 60.9012 48.8867 60.1669 50.6276C60.1529 50.6723 60.1242 50.7303 60.1095 50.7743C60.0955 50.8182 60.0668 50.8469 60.0521 50.8922C60.0094 51.0082 59.9521 51.1261 59.8934 51.2422C59.88 51.2868 59.8513 51.3454 59.822 51.4034C59.8073 51.4481 59.7933 51.4774 59.764 51.5207C59.692 51.6667 59.6199 51.8133 59.5479 51.974C59.4179 52.2525 59.2738 52.5158 59.1144 52.7797C59.1004 52.8244 59.0717 52.853 59.0577 52.897C58.1468 54.4926 57.0025 56.004 55.6237 57.4268C51.4304 61.7584 46.3466 63.95 40.3717 63.9883C34.398 64.0265 29.3015 61.8999 25.0528 57.6225Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 44,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0534 57.6265C20.804 53.3497 18.6532 48.155 18.6137 42.0557C18.5742 35.9578 20.6587 30.735 24.8532 26.4047C29.0465 22.0738 34.1156 19.8822 40.0899 19.8433C46.0642 19.805 51.1754 21.9316 55.4248 26.209C56.0425 26.8331 56.6162 27.4858 57.1459 28.1386C59.0181 30.7535 60.3804 33.5743 61.2474 36.6182C61.2767 36.7061 61.292 36.7935 61.3066 36.8814C61.3219 36.9394 61.3372 36.9975 61.3513 37.0555C61.3513 37.0555 61.3513 37.0555 61.3519 37.0708C61.3672 37.1575 61.3825 37.2448 61.3978 37.3181C61.4118 37.3328 61.4118 37.3468 61.4118 37.3614C61.5482 38.0314 61.64 38.7167 61.7172 39.402V39.4166C61.7331 39.4906 61.7331 39.5773 61.7337 39.6493C61.8753 41.1811 61.8702 42.7429 61.7204 44.3634C61.7344 44.3774 61.7344 44.3774 61.7204 44.392C61.7344 44.4067 61.7344 44.4067 61.7204 44.4214C61.7076 44.6547 61.6796 44.8886 61.6521 45.1073C61.401 47.0496 60.9018 48.8906 60.1675 50.6316C60.1535 50.6762 60.1248 50.7342 60.1101 50.7782C60.0961 50.8222 60.0674 50.8508 60.0527 50.8961C60.01 51.0121 59.9527 51.1301 59.894 51.2461C59.8806 51.2907 59.8519 51.3493 59.8226 51.4073C59.808 51.452 59.7939 51.4813 59.7646 51.5246C59.6926 51.6706 59.6205 51.8172 59.5485 51.9779C59.4185 52.2565 59.2744 52.5197 59.115 52.7836C59.101 52.8283 59.0723 52.8569 59.0583 52.9009C58.1474 54.4965 57.0031 56.0079 55.6243 57.4308C51.431 61.7623 46.3473 63.9539 40.3723 63.9922C34.3986 64.0304 29.3021 61.9038 25.0534 57.6265Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 45,
    height: 46
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8743 19.5293L62.1593 64.0294L18.5771 64.308L18.2915 19.8079L61.8743 19.5293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8735 19.5283L62.1591 64.0291L18.5762 64.3083L18.2906 19.8075L61.8735 19.5283Z",
    fill: "url(#paint0_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 44,
    height: 46
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4266 19.6807H61.9999V64.1572H18.4266V19.6807Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5563 44.4158C61.5442 44.6409 61.5168 44.8716 61.4894 45.0871C61.4887 45.0896 61.4887 45.0909 61.4887 45.0922C61.2433 46.9931 60.748 48.8366 60.0168 50.5718C60.006 50.6031 59.997 50.6247 59.9875 50.6451C59.9747 50.6751 59.9626 50.7057 59.9543 50.7312C59.9276 50.7784 59.9091 50.8096 59.8963 50.8491C59.8568 50.9543 59.802 51.0665 59.7465 51.1774C59.7261 51.2361 59.7019 51.2839 59.6777 51.333C59.6573 51.3878 59.6496 51.4037 59.6273 51.4394C59.5438 51.6039 59.4718 51.7518 59.3985 51.915C59.2805 52.1668 59.1422 52.4249 58.9752 52.7029C58.9682 52.7131 58.9631 52.7252 58.9593 52.7373C58.9363 52.7768 58.9204 52.8049 58.9083 52.8348C58.0101 54.4075 56.8652 55.917 55.5067 57.32C51.3594 61.6038 46.2667 63.7941 40.3708 63.8317C34.4844 63.8693 29.3701 61.744 25.1692 57.5151C20.9657 53.2842 18.8149 48.0851 18.776 42.0585C18.7378 36.0332 20.8216 30.8047 24.9703 26.5216C29.1163 22.2384 34.2039 20.0475 40.0903 20.0099C45.9862 19.9729 51.1057 22.0982 55.3079 26.3271C55.8752 26.9002 56.4502 27.5453 57.0182 28.2453C58.8585 30.8155 60.2304 33.6516 61.0884 36.6662C61.1177 36.7522 61.1305 36.8319 61.1451 36.9103L61.1878 37.0799C61.1878 37.0818 61.1878 37.0824 61.1878 37.0837C61.1891 37.0914 61.1897 37.0984 61.191 37.106C61.2057 37.1934 61.221 37.2807 61.2363 37.354C61.2388 37.3687 61.2439 37.3827 61.2509 37.3954C61.2509 37.3967 61.2509 37.3967 61.2509 37.3973C61.3663 37.9672 61.46 38.59 61.5531 39.4149C61.5531 39.4162 61.5531 39.4168 61.5531 39.4168C61.5531 39.4289 61.5537 39.4411 61.5563 39.4532C61.5684 39.5093 61.569 39.587 61.569 39.6514C61.569 39.6578 61.5697 39.6642 61.5697 39.6705C61.7112 41.2005 61.7067 42.7316 61.5563 44.3521V44.4158ZM61.8502 39.1408C61.7647 38.4211 61.678 37.8557 61.5722 37.3323C61.5722 37.3361 61.5748 37.3011 61.5499 37.2565C61.5486 37.2507 61.548 37.2437 61.5461 37.2373C61.5493 37.238 61.5531 37.2386 61.5563 37.2386C61.5505 37.2233 61.5454 37.2087 61.541 37.1934C61.534 37.1723 61.5359 37.1538 61.541 37.1366C61.5352 37.1047 61.5282 37.0741 61.5219 37.0423C61.5097 37.0085 61.5002 36.9734 61.4919 36.9384C61.4913 36.9358 61.4894 36.9339 61.4887 36.9314C61.4894 36.9307 61.4894 36.9307 61.4906 36.9307C61.4887 36.9237 61.4855 36.9173 61.4843 36.9103C61.4836 36.9103 61.4823 36.9103 61.4811 36.9103L61.4645 36.844C61.4505 36.7624 61.4345 36.6681 61.4001 36.5693C60.5344 33.5267 59.1467 30.6562 57.2783 28.047C56.6982 27.3318 56.1155 26.6784 55.5399 26.0976C51.274 21.8037 46.0755 19.6452 40.0884 19.6841C34.1102 19.7217 28.9449 21.9465 24.7344 26.294C20.5252 30.6409 18.4101 35.9465 18.4496 42.0598C18.4885 48.175 20.6712 53.4525 24.9358 57.7452C29.2018 62.0385 34.3952 64.197 40.3733 64.1594C46.3604 64.1211 51.5309 61.8957 55.7413 57.5482C57.1234 56.121 58.2861 54.5859 59.1989 52.9853C59.2047 52.9757 59.2091 52.9649 59.2123 52.9547C59.2353 52.9151 59.2506 52.8877 59.2627 52.8578C59.4323 52.576 59.5744 52.3121 59.6962 52.0514C59.7676 51.8901 59.839 51.7448 59.911 51.6007C59.9378 51.5605 59.9582 51.5185 59.9773 51.4617C60.0034 51.412 60.034 51.3489 60.0487 51.2998C60.1003 51.1997 60.1609 51.0773 60.2055 50.9556L60.2214 50.9237C60.2348 50.9008 60.252 50.8714 60.2654 50.8325C60.2712 50.8147 60.2801 50.7937 60.2896 50.772C60.3024 50.7427 60.3145 50.7121 60.3228 50.6866C61.0438 48.9775 61.5403 47.1518 61.7947 45.27L61.8368 44.9392C61.8553 44.7766 61.8731 44.6083 61.8827 44.4413L61.8859 44.3374C62.0325 42.7304 62.0376 41.2087 61.8999 39.6884L61.8502 39.1408Z",
    fill: "#CC6600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 40,
    width: 14,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2007 40.3613H32.7041V61.3218H19.2007V40.3613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 40,
    width: 14,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.678 53.0887C25.3962 57.5491 31.6401 62.5366 32.5861 60.9372C32.8475 60.4967 27.8498 55.8623 25.131 51.402C22.4135 46.941 20.4819 40.0908 19.8681 40.4459C18.2597 41.3772 19.9592 48.6277 22.678 53.0887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 40,
    width: 14,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.678 53.0829C25.3962 57.5432 31.6401 62.5307 32.5861 60.9313C32.8475 60.4908 27.8498 55.8565 25.131 51.3961C22.4135 46.9352 20.4819 40.085 19.8681 40.44C18.2597 41.3714 19.9592 48.6219 22.678 53.0829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 33,
    width: 35,
    height: 37
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.301 69.0505L8.2041 46.3019L28.807 33.5635L42.9039 56.3127L22.301 69.0505Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9529 67.4767L9.76245 46.1918L28.9935 34.3018L42.1839 55.5867L22.9529 67.4767Z",
    fill: "url(#paint1_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 17,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 43.8613H49.3857V58.1425H33.3567V43.8613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 17,
    height: 16
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4823 43.8975C33.4823 43.8975 33.4141 53.9943 39.3617 57.3741C41.3518 58.505 44.5953 59.1526 47.0291 52.37C47.0291 52.37 48.3557 49.0807 49.3546 48.7683L48.1491 48.7569C48.1491 48.7569 46.0684 51.7829 46.0359 52.6224C46.0359 52.6224 44.258 59.4765 39.048 55.834C39.048 55.834 35.563 54.0657 34.5463 47.3876L33.4823 43.8975Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 17,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4821 43.8984C33.4821 43.8984 33.4139 53.9952 39.3614 57.3751C41.3516 58.5059 44.595 59.1536 47.0289 52.371C47.0289 52.371 48.3554 49.0817 49.3543 48.7693L48.1489 48.7578C48.1489 48.7578 46.0682 51.7839 46.0357 52.6234C46.0357 52.6234 44.2578 59.4774 39.0478 55.835C39.0478 55.835 35.5628 54.0666 34.546 47.3886L33.4821 43.8984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 42,
    width: 19,
    height: 19
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0676 59.3595L49.2346 60.8518L50.7007 44.0145L33.5338 42.5234L32.0676 59.3595Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1825 58.0361L49.2347 59.517L50.5848 44.0043L33.5333 42.5234L32.1825 58.0361Z",
    fill: "url(#paint2_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 22,
    width: 32,
    height: 22
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7467 22.7754H57.1825V43.6485H26.7467V22.7754Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 22,
    width: 32,
    height: 22
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0361 29.7641C24.8802 34.5623 37.9112 32.0175 45.5328 35.2552C53.1549 38.4942 54.4745 46.9992 56.5354 42.159C58.597 37.318 55.3886 27.9333 47.8971 24.4068C40.4305 20.8931 29.9601 23.2594 27.0361 29.7641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 22,
    width: 32,
    height: 22
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0364 29.7631C24.8805 34.5613 37.9116 32.0166 45.5331 35.2542C53.1553 38.4932 54.4748 46.9982 56.5358 42.158C58.5973 37.3171 55.389 27.9323 47.8975 24.4059C40.4309 20.8922 29.9605 23.2584 27.0364 29.7631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 14,
    width: 43,
    height: 40
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 14.7549L62.816 21.6822L57.5748 53.1315L20.6611 46.2042L25.903 14.7549Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6744 17.2109L60.6925 23.4071L56.3915 49.2104L23.3734 43.0142L27.6744 17.2109Z",
    fill: "url(#paint3_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 35,
    width: 10,
    height: 7
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6821 35.3779H37.5824V41.0896H28.6821V35.3779Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 35,
    width: 10,
    height: 7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.726 36.0187C28.5768 36.5879 29.9257 37.9349 31.7112 38.4149C33.4981 38.8943 37.0844 41.4492 37.3815 40.9424C38.2529 39.4597 33.9704 36.1551 32.1842 35.6751C30.3981 35.1957 28.8758 35.4494 28.726 36.0187Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 35,
    width: 10,
    height: 7
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7259 36.0157C28.5767 36.585 29.9256 37.932 31.7111 38.412C33.4979 38.8913 37.0843 41.4463 37.3814 40.9395C38.2528 39.4568 33.9703 36.1522 32.1841 35.6721C30.3979 35.1928 28.8757 35.4465 28.7259 36.0157Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 32,
    width: 13,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7887 35.6062L37.6143 43.8735L27.0406 41.0349L29.2144 32.7676L39.7887 35.6062Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0071 35.7226L36.9959 43.3703L27.2587 40.7561L29.2692 33.1084L39.0071 35.7226Z",
    fill: "url(#paint4_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 16,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 43.0684H48.9988V57.2437H33.3567V43.0684Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 16,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6832 44.2957C34.7457 44.3294 34.812 44.3785 34.8624 44.4289C35.081 46.2163 35.8638 47.7048 37.228 48.9033C38.1995 49.7989 39.3246 50.5179 40.5906 51.0764C40.8864 51.1937 41.1937 51.2963 41.4965 51.3562C44.1279 51.9937 45.8255 51.1191 46.5611 48.7388C47.407 48.7847 48.1707 48.7707 48.8821 48.6923C47.822 49.4827 46.9315 50.9049 46.2258 52.941C45.3149 55.5565 43.8959 56.9914 41.9395 57.2311C41.8643 57.2273 41.7776 57.2381 41.689 57.2356C42.009 56.3004 41.826 55.3448 41.1427 54.3963C40.62 53.6702 39.6893 53.1953 38.348 52.9728C38.028 52.3188 37.6073 51.8063 37.1037 51.4455C36.6014 51.0993 36.0474 50.9164 35.4431 50.91L35.2831 50.931C35.2315 50.7532 35.1773 50.5753 35.111 50.3994C34.3326 48.0459 33.78 45.6197 33.4517 43.1074C33.5409 43.2241 33.6442 43.3388 33.7334 43.4542C34.0496 43.7398 34.3671 44.0247 34.6832 44.2957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 43,
    width: 16,
    height: 15
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6832 44.2937C34.7457 44.3275 34.812 44.3766 34.8624 44.4269C35.081 46.2144 35.8638 47.7029 37.228 48.9013C38.1995 49.7969 39.3246 50.516 40.5906 51.0744C40.8864 51.1917 41.1937 51.2943 41.4965 51.3543C44.1279 51.9917 45.8255 51.1171 46.5611 48.7368C47.407 48.7827 48.1707 48.7687 48.8821 48.6903C47.822 49.4808 46.9315 50.9029 46.2258 52.939C45.3149 55.5545 43.8959 56.9894 41.9395 57.2291C41.8643 57.2253 41.7776 57.2361 41.689 57.2336C42.009 56.2984 41.826 55.3429 41.1427 54.3943C40.62 53.6683 39.6893 53.1933 38.348 52.9709C38.028 52.3168 37.6073 51.8043 37.1037 51.4435C36.6014 51.0974 36.0474 50.9144 35.4431 50.908L35.2831 50.9291C35.2315 50.7512 35.1773 50.5734 35.111 50.3974C34.3326 48.0439 33.78 45.6177 33.4517 43.1055C33.5409 43.2221 33.6442 43.3369 33.7334 43.4522C34.0496 43.7378 34.3671 44.0228 34.6832 44.2937Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 41,
    width: 20,
    height: 19
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6244 41.1318L50.6956 57.0015L33.7097 59.2135L31.6385 43.3432L48.6244 41.1318Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6243 41.1318L50.6954 57.0015L33.7096 59.2129L31.6384 43.3432L48.6243 41.1318Z",
    fill: "url(#paint5_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 39,
    width: 23,
    height: 10
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7253 39.6191H53.4297V48.8668H31.7253V39.6191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 39,
    width: 23,
    height: 10
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4245 46.4208C53.4245 46.4208 51.3661 43.4611 45.2145 41.4983C39.87 39.7938 35.4709 40.0749 31.7296 39.7695C31.7296 39.7695 32.7056 46.178 43.4596 48.39C43.4596 48.39 50.5438 50.2641 53.4245 46.4208Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 39,
    width: 23,
    height: 10
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4241 46.4199C53.4241 46.4199 51.3657 43.4601 45.2142 41.4974C39.8697 39.7928 35.4705 40.0739 31.7292 39.7686C31.7292 39.7686 32.7052 46.177 43.4592 48.389C43.4592 48.389 50.5434 50.2631 53.4241 46.4199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 35,
    width: 27,
    height: 21
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8361 35L55.7357 40.3018L52.3183 55.0279L29.418 49.7267L32.8361 35Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.835 35L55.4274 40.2304L52.3179 53.6312L29.7255 48.4008L32.835 35Z",
    fill: "url(#paint6_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 50,
    width: 7,
    height: 8
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2611 50.8799H41.8429V57.2443H35.2611V50.8799Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 50,
    width: 7,
    height: 8
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2832 50.9331L35.4432 50.9121C36.0475 50.9185 36.6015 51.1014 37.1038 51.4476C37.6074 51.8084 38.0281 52.3209 38.3481 52.9749C39.6894 53.1974 40.6201 53.6723 41.1428 54.3984C41.8261 55.347 42.0091 56.3025 41.6891 57.2377C41.6151 57.2332 41.5259 57.23 41.4373 57.2281C39.1074 57.0917 37.2275 55.4489 35.8314 52.3088C35.6427 51.8785 35.4649 51.4202 35.2832 50.9331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 50,
    width: 7,
    height: 8
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2827 50.9361L35.4427 50.915C36.047 50.9214 36.601 51.1044 37.1033 51.4505C37.6069 51.8113 38.0276 52.3238 38.3476 52.9779C39.6889 53.2004 40.6196 53.6753 41.1423 54.4013C41.8257 55.3499 42.0086 56.3054 41.6886 57.2406C41.6147 57.2361 41.5254 57.233 41.4368 57.231C39.1069 57.0946 37.227 55.4519 35.8309 52.3117C35.6422 51.8814 35.4644 51.4231 35.2827 50.9361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 49,
    width: 11,
    height: 10
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6467 58.7555L33.8544 56.8998L35.645 49.3994L43.4374 51.2551L41.6467 58.7555Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6467 58.7555L33.8544 56.9005L35.645 49.3994L43.4374 51.2551L41.6467 58.7555Z",
    fill: "url(#paint7_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 44,
    width: 13,
    height: 8
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8253 44.4209H46.5751V51.572H34.8253V44.4209Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 44,
    width: 13,
    height: 8
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2278 48.9041C35.8636 47.7056 35.0808 46.2171 34.8622 44.4297C38.1719 47.1064 42.0426 48.5464 46.4864 48.7345C46.517 48.7447 46.5456 48.7409 46.5609 48.7396C45.8253 51.1192 44.1277 51.9945 41.4963 51.357C41.1935 51.2971 40.8862 51.1945 40.5904 51.0772C39.3244 50.5188 38.1993 49.7997 37.2278 48.9041Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 44,
    width: 13,
    height: 8
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2281 48.9041C35.8639 47.7056 35.0811 46.2171 34.8624 44.4297C38.1721 47.1064 42.0428 48.5464 46.4866 48.7345C46.5172 48.7447 46.5459 48.7409 46.5612 48.7396C45.8255 51.1192 44.128 51.9945 41.4965 51.357C41.1937 51.2971 40.8865 51.1945 40.5907 51.0772C39.3247 50.5188 38.1996 49.7997 37.2281 48.9041Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 42,
    width: 16,
    height: 13
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3777 42.0342L48.1149 44.7644L46.045 54.394L33.3079 51.6631L35.3777 42.0342Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3769 42.0342L48.0274 44.746L46.0455 53.9701L33.395 51.2583L35.3769 42.0342Z",
    fill: "url(#paint8_linear_1570_1141)"
  })))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7094 57.3934C41.77 57.3852 41.8235 57.3444 41.8446 57.2851C42.1812 56.2989 41.9899 55.2981 41.2766 54.3081C40.743 53.5648 39.7958 53.0689 38.4603 52.833C38.1339 52.1936 37.7106 51.6849 37.2019 51.3203C36.6652 50.9499 36.0755 50.7606 35.4463 50.7549L35.2627 50.7766C35.1729 50.788 35.1098 50.8671 35.1206 50.9538C35.1321 51.0398 35.2137 51.1004 35.3035 51.0883L35.4636 51.0679C36.0016 51.0755 36.5281 51.2457 37.0075 51.5759C37.4907 51.9208 37.8917 52.4142 38.1996 53.0408C38.2002 53.0421 38.2008 53.044 38.2015 53.0453C38.4705 53.5833 38.6687 54.1787 38.7918 54.8136C38.8096 54.8978 38.8874 54.9602 38.9836 54.9379C39.0716 54.9207 39.1309 54.8385 39.1137 54.7524C39.0059 54.1985 38.8434 53.6738 38.6286 53.1874C39.7543 53.4214 40.5537 53.8581 41.0076 54.4892C41.6597 55.3931 41.8369 56.3021 41.5341 57.1888C41.5061 57.2717 41.552 57.3603 41.6374 57.3877C41.6616 57.3947 41.6858 57.3966 41.7094 57.3934Z",
    fill: "#B90000"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0707 52.8942C45.1776 55.4606 43.8306 56.8286 41.9533 57.0728C41.9424 57.0747 41.931 57.076 41.9201 57.0766C41.9061 57.0734 41.8577 57.0747 41.8067 57.0772C41.771 57.0798 41.7333 57.0811 41.6957 57.0804C41.6256 57.0766 41.5376 57.0734 41.4478 57.0702C39.1867 56.9383 37.3463 55.3147 35.9821 52.2459C35.7782 51.7818 35.5927 51.2942 35.4371 50.8785C35.3868 50.7039 35.3326 50.5235 35.265 50.3463C34.551 48.1872 34.0213 45.9293 33.6892 43.6299C33.9945 43.9079 34.2852 44.1679 34.574 44.4159C34.5823 44.4236 34.5918 44.4306 34.602 44.4357C34.6518 44.4631 34.7053 44.502 34.7448 44.5415C38.082 47.2412 42.0196 48.7016 46.4595 48.8928C46.5156 48.9056 46.5621 48.8998 46.5819 48.8973C47.2213 48.9343 47.8231 48.9343 48.3929 48.8954C47.4782 49.7432 46.6986 51.0857 46.0707 52.8942ZM50.9989 45.7049C50.7987 45.6934 50.7375 45.9879 50.99 46.0134C51.4834 46.065 51.7231 46.0485 52.1221 46.1364C52.1253 46.1371 52.6423 46.2333 52.6404 46.2365C52.9075 46.2996 52.9291 46.3022 53.246 46.3895C52.1661 47.5905 50.6904 48.3274 48.8659 48.5378C48.8647 48.5378 48.864 48.5378 48.8621 48.5378C48.1647 48.6143 47.4157 48.6296 46.5723 48.5837C46.5685 48.5824 46.5373 48.5856 46.5335 48.5856C46.5182 48.5805 46.5118 48.5786 46.4958 48.5786C42.1203 48.3937 38.242 46.9575 34.9679 44.3095C34.9227 44.2629 34.8532 44.21 34.7805 44.1692C34.4694 43.9021 34.1577 43.6216 33.846 43.3412C33.8205 43.3035 33.7721 43.2449 33.7236 43.1869C33.6771 43.1302 33.6299 43.0747 33.5859 43.018C33.5846 43.0154 33.584 43.0141 33.5815 43.0116C32.8713 42.1026 32.3314 41.0692 31.9731 39.9352C32.7457 40.2756 33.5228 40.7887 34.3394 41.4944C34.4063 41.5518 34.509 41.5454 34.5702 41.481C34.6314 41.416 34.6256 41.3172 34.5587 41.2586C33.6038 40.4324 32.6947 39.8612 31.7832 39.5132C30.1557 38.8572 28.7909 38.9401 27.7302 39.7592C27.6594 39.8141 27.6473 39.9129 27.7034 39.9804C27.7595 40.0493 27.8621 40.0595 27.9322 40.0047C28.8776 39.2748 30.1047 39.1989 31.5836 39.7771C31.9457 41.0316 32.522 42.174 33.2959 43.1716C33.6229 45.6622 34.1819 48.1113 34.9552 50.4508C35.0228 50.6293 35.075 50.8027 35.126 50.9773C35.286 51.4076 35.4741 51.9004 35.6813 52.3715C37.0983 55.5588 39.0318 57.2455 41.4261 57.3851C41.5198 57.3883 41.6065 57.3915 41.6779 57.3953C41.7302 57.3966 41.7754 57.3941 41.82 57.3928C41.857 57.3909 41.894 57.3883 41.9278 57.3915C41.9412 57.389 41.9552 57.3871 41.9692 57.3851C43.9836 57.1231 45.4574 55.6461 46.3811 52.9924C47.0664 51.0143 47.9295 49.6202 48.9469 48.8444C48.9546 48.8444 48.9622 48.8431 48.9698 48.8425C50.8963 48.592 52.444 47.804 53.5736 46.503C54.1461 46.7102 54.7829 47.0372 55.4643 47.4745C55.5396 47.521 55.6416 47.5025 55.6913 47.4292C55.7416 47.3572 55.7219 47.259 55.6473 47.2118C54.9015 46.7331 54.206 46.3825 53.5806 46.1683C53.58 46.1683 53.5794 46.1677 53.5787 46.1677C53.2339 46.0389 52.7366 45.8834 52.4408 45.8445C51.9264 45.752 51.6529 45.7246 51.1124 45.7068L50.9989 45.7049Z",
    fill: "#CC6600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 51,
    width: 3,
    height: 3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0348 51.377H38.0893V53.696H36.0348V51.377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 51,
    width: 3,
    height: 3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9795 53.6212C37.7398 53.8137 37.1329 53.4892 36.6236 52.897C36.113 52.3048 35.8931 51.6686 36.1327 51.4774C36.3718 51.2849 36.9793 51.6093 37.488 52.2015C37.998 52.7937 38.2179 53.4293 37.9795 53.6212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 51,
    width: 3,
    height: 3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9795 53.6231C37.7398 53.8156 37.1329 53.4912 36.6236 52.899C36.113 52.3068 35.8931 51.6706 36.1327 51.4793C36.3718 51.2868 36.9793 51.6113 37.488 52.2035C37.998 52.7957 38.2179 53.4312 37.9795 53.6231Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 50,
    width: 6,
    height: 5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4139 50.1748L39.4225 52.9331L36.6986 54.9131L34.6893 52.1541L37.4139 50.1748Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4267 50.3672L39.2684 52.8954L36.7714 54.7096L34.9304 52.1814L37.4267 50.3672Z",
    fill: "url(#paint9_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 53,
    width: 3,
    height: 3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2316 53.5029H41.0267V55.4357H39.2316V53.5029Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 53,
    width: 2,
    height: 3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8516 55.3353C40.6495 55.5011 40.1555 55.2608 39.7481 54.798C39.3408 54.3358 39.1744 53.8252 39.3771 53.6594C39.5792 53.4924 40.0732 53.7334 40.4806 54.1962C40.8879 54.659 41.0543 55.1683 40.8516 55.3353Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 53,
    width: 2,
    height: 3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8513 55.3383C40.6493 55.504 40.1552 55.2637 39.7479 54.8009C39.3406 54.3387 39.1742 53.8281 39.3769 53.6624C39.579 53.4954 40.073 53.7363 40.4803 54.1991C40.8877 54.6619 41.0541 55.1713 40.8513 55.3383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 52,
    width: 5,
    height: 5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1376 52.5498L42.0519 54.5247L40.0917 56.4505L38.1768 54.4756L40.1376 52.5498Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1376 52.5596L42.0136 54.4956L40.0917 56.3844L38.215 54.4484L40.1376 52.5596Z",
    fill: "url(#paint10_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 36,
    width: 10,
    height: 6
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1764 36.8857H35.1519V41.5246H26.1764V36.8857Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 36,
    width: 10,
    height: 6
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3257 39.5226C26.3843 39.9739 27.2838 39.1318 29.761 38.8093C32.2369 38.4867 35.1469 41.8251 35.0876 41.3738C35.029 40.9225 32.8571 36.6107 30.3812 36.9332C27.9047 37.2558 26.2664 39.0713 26.3257 39.5226Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 36,
    width: 10,
    height: 6
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3257 39.5216C26.3843 39.973 27.2838 39.1309 29.761 38.8083C32.2369 38.4858 35.1469 41.8242 35.0876 41.3728C35.029 40.9215 32.8571 36.6097 30.3812 36.9323C27.9047 37.2548 26.2664 39.0703 26.3257 39.5216Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 36,
    width: 10,
    height: 7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2779 36.2939L35.3324 36.6159L35.1361 42.1382L26.0815 41.8176L26.2779 36.2939Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2777 36.5664L35.3113 36.8877L35.1353 41.8351L26.1018 41.5144L26.2777 36.5664Z",
    fill: "url(#paint11_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 44,
    width: 6,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8185 44.6777H55.8774V47.2888H50.8185V44.6777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 44,
    width: 6,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.792 47.2802C55.792 47.2802 54.9321 46.3986 53.5258 46.0301C52.6812 45.8076 52.031 45.5903 50.8842 45.6789C50.8842 45.6789 54.0077 42.7912 55.792 47.2802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 44,
    width: 6,
    height: 4
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7919 47.2821C55.7919 47.2821 54.9319 46.4005 53.5257 46.0321C52.681 45.8096 52.0308 45.5922 50.884 45.6808C50.884 45.6808 54.0076 42.7931 55.7919 47.2821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 41,
    width: 9,
    height: 8
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M51.465 41.208L57.243 43.3238L55.2101 48.8652L49.4315 46.7495L51.465 41.208Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4646 43.0332L56.6529 44.9322L55.2103 48.8641L50.022 46.9651L51.4646 43.0332Z",
    fill: "url(#paint12_linear_1570_1141)"
  })))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6835 57.8796C44.5573 58.4737 42.9738 60.191 40.4526 59.6568C37.9321 59.1233 35.9279 57.0719 36.0548 56.4784C36.1804 55.8849 38.1144 57.7329 40.6356 58.2678C43.1561 58.8007 44.8097 57.2861 44.6835 57.8796Z",
    fill: "#F2A711"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 27,
    width: 12,
    height: 15
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9065 27.7998H44.1276V41.7399H33.9065V27.7998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 27,
    width: 12,
    height: 15
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1826 35.8676C34.8296 37.1738 36.3328 37.1266 37.1889 38.2817C38.1999 39.6452 37.6032 41.8011 39.1548 41.7348C42.0202 41.6124 44.1608 38.0847 44.0015 34.3562C43.8421 30.6283 42.3377 27.6889 39.4735 27.8113C36.6081 27.9331 33.1212 33.7289 34.1826 35.8676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 27,
    width: 12,
    height: 15
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1831 35.8695C34.8301 37.1757 36.3332 37.1285 37.1894 38.2836C38.2004 39.6472 37.6037 41.8031 39.1553 41.7368C42.0207 41.6144 44.1613 38.0866 44.0019 34.3581C43.8426 30.6302 42.3382 27.6909 39.474 27.8133C36.6086 27.935 33.1217 33.7308 34.1831 35.8695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 27,
    width: 13,
    height: 16
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1404 27.2188L44.7626 41.7746L33.1416 42.2699L32.5194 27.7141L44.1404 27.2188Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1425 27.3643L44.7583 41.7773L33.9252 42.2395L33.3094 27.8258L44.1425 27.3643Z",
    fill: "url(#paint13_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 29,
    width: 10,
    height: 13
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8741 29.7344H43.7744V41.5236H34.8741V29.7344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 29,
    width: 10,
    height: 13
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0759 31.0395C36.3588 31.6987 35.7933 32.4968 35.3796 33.4345C35.1559 33.998 35.0182 34.5449 34.9666 35.0581C34.9844 35.4807 34.9991 36.4828 35.1476 36.8711C36.8152 38.2601 37.9282 39.3572 38.3496 41.3397C39.6538 41.7661 40.8051 41.3371 41.79 40.0832C42.6117 39.1277 43.1745 37.9356 43.4933 36.5052C43.6042 36.0041 43.6858 35.519 43.71 35.0498C43.7138 34.1159 43.5443 33.2318 43.202 32.4145C42.6302 31.0077 41.746 30.1694 40.5501 29.8991C39.3549 29.6288 38.1877 30.0145 37.0759 31.0395Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 29,
    width: 10,
    height: 13
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0759 31.0395C36.3588 31.6987 35.7933 32.4968 35.3796 33.4345C35.1559 33.998 35.0182 34.5449 34.9666 35.0581C34.9844 35.4807 34.9991 36.4828 35.1476 36.8711C36.8152 38.2601 37.9282 39.3572 38.3496 41.3397C39.6538 41.7661 40.8051 41.3371 41.79 40.0832C42.6117 39.1277 43.1745 37.9356 43.4933 36.5052C43.6042 36.0041 43.6858 35.519 43.71 35.0498C43.7138 34.1159 43.5443 33.2318 43.202 32.4145C42.6302 31.0077 41.746 30.1694 40.5501 29.8991C39.3549 29.6288 38.1877 30.0145 37.0759 31.0395Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 29,
    width: 11,
    height: 14
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.698 29.2559L44.2315 41.7432L34.9819 42.1377L34.4484 29.6498L43.698 29.2559Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6978 29.3574L44.2161 41.4973L34.9824 41.8913L34.4635 29.7507L43.6978 29.3574Z",
    fill: "url(#paint14_radial_1570_1141)"
  })))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3553 24.1641C44.3553 24.1641 43.1518 23.4757 41.8647 23.6522C40.192 23.8811 37.778 24.9833 37.8398 24.9667C37.9539 24.9361 42.1446 19.7745 43.795 22.4417C44.5032 23.5866 44.3553 24.1641 44.3553 24.1641Z",
    fill: "#D68607"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 32,
    width: 6,
    height: 7
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2949 32.4395H41.3538V38.8039H36.2949V32.4395Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 32,
    width: 6,
    height: 7
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6848 33.1603C38.261 32.6688 38.8819 32.4973 39.5328 32.6471C40.1843 32.7957 40.67 33.21 41.006 33.8889C41.3253 34.5831 41.3903 35.3372 41.1997 36.1672C41.0251 36.9959 40.6343 37.6576 40.058 38.1325C39.4665 38.6246 38.8443 38.7961 38.1935 38.6463C37.542 38.4978 37.0569 38.0834 36.7369 37.4039C36.4015 36.7097 36.3365 35.939 36.5106 35.1103C36.7012 34.2816 37.0926 33.6365 37.6848 33.1603Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 32,
    width: 6,
    height: 7
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6845 33.1593C38.2608 32.6678 38.8817 32.4963 39.5325 32.6462C40.184 32.7947 40.6698 33.209 41.0057 33.8879C41.3251 34.5821 41.3901 35.3363 41.1995 36.1662C41.0248 36.9949 40.6341 37.6566 40.0578 38.1315C39.4662 38.6237 38.8441 38.7951 38.1932 38.6453C37.5417 38.4968 37.0566 38.0825 36.7366 37.4029C36.4013 36.7087 36.3363 35.938 36.5103 35.1093C36.7009 34.2806 37.0923 33.6355 37.6845 33.1593Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 32,
    width: 6,
    height: 8
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3795 32.2803L41.6575 38.7824L36.3448 39.0087L36.0669 32.5066L41.3795 32.2803Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3805 32.2803L41.6584 38.7824L36.3452 39.0087L36.0679 32.5066L41.3805 32.2803Z",
    fill: "url(#paint15_radial_1570_1141)"
  })))))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0109 32.7777C38.5928 32.7949 38.1861 32.9702 37.7985 33.3017C37.2318 33.7569 36.8684 34.3618 36.6874 35.1491C36.5184 35.9529 36.5898 36.6854 36.9009 37.3286C37.1986 37.9603 37.6346 38.3351 38.2339 38.4722C38.3964 38.5092 38.559 38.5244 38.7171 38.5187C39.134 38.5002 39.547 38.3243 39.9429 37.9954C40.4956 37.5396 40.8589 36.9117 41.0234 36.1282C41.2064 35.3339 41.1471 34.6257 40.8436 33.9691C40.5294 33.3348 40.0882 32.96 39.4929 32.823C39.3309 32.786 39.1684 32.7701 39.0109 32.7777ZM38.7317 38.8789C38.5424 38.8872 38.3473 38.868 38.1529 38.8234C37.4485 38.6609 36.9175 38.2102 36.5752 37.4835C36.2297 36.7695 36.1494 35.9587 36.3355 35.0713C36.5325 34.212 36.9487 33.5223 37.5683 33.0238C38.1841 32.4985 38.8681 32.3104 39.5738 32.4724C40.2712 32.6324 40.8073 33.0824 41.1694 33.8142C41.5034 34.5409 41.5729 35.346 41.3759 36.2054C41.1942 37.0685 40.7895 37.7633 40.1737 38.2727C39.7153 38.6526 39.2302 38.8566 38.7317 38.8789Z",
    fill: "#001D57"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6348 36.9155C37.4398 36.4897 37.4034 36.0243 37.5265 35.5035C37.6501 34.9834 37.8739 34.5703 38.2315 34.249C38.5904 33.9602 38.955 33.8487 39.3305 33.9283C39.7053 34.0252 39.989 34.2713 40.1681 34.6825C40.3645 35.1089 40.4002 35.5902 40.2778 36.111C40.1554 36.6312 39.9304 37.0436 39.5727 37.3483C39.2311 37.669 38.8651 37.7818 38.4903 37.6849C38.1161 37.604 37.8312 37.3432 37.6348 36.9155Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4973 34.7111C37.3973 34.4905 37.3864 34.2489 37.4738 34.0009C37.5617 33.753 37.723 33.5668 37.9417 33.4495C38.1616 33.3316 38.3911 33.3048 38.625 33.3801C38.859 33.4559 39.0241 33.6089 39.1248 33.8301C39.2255 34.0507 39.2357 34.2923 39.1484 34.5396C39.0604 34.7882 38.8998 34.9737 38.6798 35.0917C38.4605 35.2096 38.2304 35.2357 37.9971 35.1605C37.7625 35.0846 37.5981 34.9316 37.4973 34.7111Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6621 37.7236C38.5709 37.5859 38.5384 37.4387 38.5645 37.2812C38.5913 37.1231 38.6703 36.9969 38.8017 36.9026C38.9196 36.807 39.0611 36.7795 39.2052 36.807C39.3492 36.835 39.4723 36.9128 39.5641 37.0498C39.6444 37.185 39.6756 37.3316 39.6495 37.4903C39.6227 37.6478 39.5443 37.774 39.4257 37.8702C39.2951 37.9646 39.1535 37.9914 39.0101 37.9646C38.8654 37.9359 38.7417 37.8581 38.6621 37.7236Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5648 24.8322C39.1138 22.7464 40.506 21.5811 41.8205 21.2713C42.0729 21.212 42.3254 21.184 42.5682 21.1891C42.9596 21.1935 43.3058 21.2955 43.5984 21.4919C44.2123 21.9049 44.5743 22.7432 44.7037 24.0532C44.7101 24.1138 44.6674 24.166 44.5941 24.1896C44.5877 24.1909 44.5826 24.1934 44.5762 24.1947C44.5061 24.2106 44.4092 24.2138 44.355 24.1635C43.402 23.2704 42.4095 22.9912 41.0727 23.3067C40.1733 23.519 38.9748 24.4529 37.9319 25.054C37.8535 25.0999 37.7286 25.0929 37.6381 25.0381C37.5482 24.9839 37.517 24.8959 37.5648 24.8322Z",
    fill: "#774104"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 21,
    width: 7,
    height: 4
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M38.416 21.3418H44.1277V24.2792H38.416V21.3418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 21,
    width: 7,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0352 22.6959C44.0352 22.6959 42.9343 18.9495 38.5027 24.1556C38.5027 24.1556 42.629 21.5969 44.0352 22.6959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 21,
    width: 7,
    height: 4
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0354 22.6988C44.0354 22.6988 42.9345 18.9524 38.5028 24.1586C38.5028 24.1586 42.6291 21.5998 44.0354 22.6988Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 18,
    width: 8,
    height: 8
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9036 18.1084L37.7068 19.0786L38.6368 25.0051L44.8336 24.0349L43.9036 18.1084Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9033 20.3867L38.0552 21.3021L38.6359 25.0039L44.484 24.0885L43.9033 20.3867Z",
    fill: "url(#paint16_linear_1570_1141)"
  })))))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4242 41.6621C40.3422 41.6225 41.1785 41.1291 41.9186 40.1844C42.7435 39.2269 43.3287 37.9992 43.6544 36.5419C43.7819 35.9612 43.8508 35.4901 43.8737 35.0598C43.8782 34.9693 43.8087 34.8935 43.7188 34.889C43.6276 34.8833 43.5518 34.9534 43.5467 35.0433C43.5257 35.4551 43.4587 35.9096 43.3344 36.4712C43.0214 37.8755 42.4611 39.0542 41.6662 39.9779C40.7214 41.1814 39.6244 41.5843 38.4004 41.1859C38.3157 41.1578 38.2232 41.2044 38.1939 41.2898C38.1671 41.3758 38.213 41.4683 38.2991 41.4963C38.686 41.6219 39.0608 41.678 39.4242 41.6621Z",
    fill: "#6A3500"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1315 36.9921C35.1481 36.9902 35.1653 36.9845 35.1838 36.9743C35.2705 36.9265 35.3266 36.9309 35.2986 36.8181C35.1813 36.3457 35.1175 35.6783 35.1233 35.1008C35.1245 34.979 35.0512 34.8885 34.9601 34.8993C34.8683 34.9089 34.7937 35.016 34.7924 35.1377C34.7854 35.7631 34.8472 36.3419 34.976 36.8589C34.9977 36.9481 35.0621 36.9991 35.1315 36.9921Z",
    fill: "#6A3500"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7672 43.3571C38.8481 43.338 38.9023 43.2577 38.8902 43.1716C38.7869 42.4519 38.6461 41.8348 38.4612 41.286L38.4484 41.2197C38.3904 41.0189 38.3235 40.8487 38.2591 40.6842C37.5216 38.7941 36.2046 37.2846 34.3457 36.1996C34.2979 36.1748 34.2628 36.1557 34.2278 36.1359C34.1883 36.1129 34.1481 36.0906 34.1054 36.0696C34.0079 36.0046 33.8874 35.9466 33.7599 35.8854L33.7102 35.8611C32.4869 35.2409 31.0946 34.8571 29.5737 34.7194C29.4857 34.7112 29.4085 34.7775 29.3996 34.868C29.3907 34.9572 29.4557 35.0363 29.5424 35.0452C31.0245 35.1784 32.3798 35.552 33.5699 36.1557L33.6228 36.1805C33.7465 36.2398 33.853 36.2914 33.9486 36.3539C34.0028 36.382 34.0365 36.4024 34.0722 36.4208C34.1111 36.4438 34.1513 36.4667 34.1953 36.4884C35.9821 37.5326 37.2526 38.9879 37.9646 40.8079C38.0252 40.9653 38.0883 41.1292 38.1405 41.3045L38.1552 41.3771C38.3388 41.9247 38.4746 42.5227 38.5759 43.2232C38.5887 43.3125 38.669 43.3724 38.757 43.3584C38.7608 43.3577 38.7633 43.3577 38.7672 43.3571Z",
    fill: "#CC6600"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3728 31.7687C42.7832 30.3166 41.8518 29.4375 40.6062 29.1557C39.3568 28.8727 38.1386 29.2705 36.9848 30.3363C36.2536 31.0069 35.6703 31.8305 35.2496 32.7848C34.9392 33.5951 34.7894 34.3594 34.8034 35.0625C34.8059 35.153 34.8799 35.2238 34.971 35.2225C34.9717 35.2225 34.973 35.2225 34.9736 35.2225C35.0628 35.2187 35.1196 35.1441 35.131 35.0561C35.1763 34.7062 35.1534 34.6239 35.3 33.9278C35.3937 33.4848 35.5358 33.1954 35.5722 33.1221C35.9853 32.1843 36.3594 31.6999 37.0766 31.0407C38.1883 30.0157 39.3555 29.63 40.5508 29.9003C41.7467 30.1706 42.6308 31.0089 43.2026 32.4157C43.2817 32.6051 43.3512 32.7989 43.4117 32.9965C43.552 33.646 43.5979 34.3294 43.5469 35.0408C43.5411 35.1307 43.6087 35.2078 43.6986 35.2142C43.7049 35.2148 43.7113 35.2149 43.7171 35.2149C43.7993 35.2117 43.8675 35.1473 43.8739 35.0631C43.9567 33.8864 43.7885 32.7778 43.3728 31.7687Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 30,
    width: 6,
    height: 5
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2979 30.8926H33.5193V34.2335H28.2979V30.8926Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 30,
    width: 6,
    height: 5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5671 33.153C31.93 34.0008 33.189 34.4406 33.3783 34.1359C33.5689 33.8319 32.6185 32.8967 31.2549 32.0501C29.8927 31.2023 28.6337 30.7612 28.4431 31.0665C28.2544 31.3712 29.2042 32.3058 30.5671 33.153Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 30,
    width: 6,
    height: 5
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5674 33.1539C31.9302 34.0018 33.1892 34.4416 33.3786 34.1369C33.5692 33.8328 32.6187 32.8977 31.2552 32.0511C29.8929 31.2033 28.6339 30.7622 28.4433 31.0675C28.2546 31.3722 29.2045 32.3067 30.5674 33.1539Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 28,
    width: 8,
    height: 9
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0233 28.2891L34.5476 31.2953L32.7991 36.9159L27.2748 33.909L29.0233 28.2891Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.051 28.4639L34.4446 31.3994L32.7623 36.8057L27.3694 33.8708L29.051 28.4639Z",
    fill: "url(#paint17_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 40,
    width: 5,
    height: 2
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2244 40.5957H59.4476V41.9012H55.2244V40.5957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 40,
    width: 5,
    height: 2
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4852 41.7879C58.5982 41.6043 59.4167 41.2263 59.3128 40.9426C59.2089 40.6576 58.2221 40.5754 57.1078 40.759C55.9942 40.9413 55.1757 41.3206 55.2802 41.6043C55.3848 41.8886 56.3716 41.9708 57.4852 41.7879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 40,
    width: 5,
    height: 2
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4844 41.7908C58.5974 41.6072 59.4159 41.2292 59.312 40.9455C59.2081 40.6606 58.2213 40.5783 57.107 40.7619C55.9933 40.9442 55.1748 41.3235 55.2794 41.6072C55.3839 41.8915 56.3707 41.9738 57.4844 41.7908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 40,
    width: 5,
    height: 3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1426 40.5782L59.4104 40.3066L59.4499 41.9685L55.1827 42.2401L55.1426 40.5782Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1584 40.5789L59.4103 40.3086L59.4486 41.9067L55.1967 42.177L55.1584 40.5789Z",
    fill: "url(#paint18_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 7,
    height: 4
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2069 40.1084H54.4082V43.6986H48.2069V40.1084Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 7,
    height: 4
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3934 40.5951C54.3934 40.5951 54.445 41.4857 53.5418 41.907C53.5418 41.907 49.9477 42.4132 48.4248 43.6773C48.4248 43.6773 48.0092 41.6151 48.3305 41.1281C48.3305 41.1281 52.9483 39.3196 54.3934 40.5951Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 7,
    height: 4
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M54.393 40.5961C54.393 40.5961 54.4447 41.4867 53.5414 41.908C53.5414 41.908 49.9474 42.4142 48.4245 43.6783C48.4245 43.6783 48.0088 41.6161 48.3301 41.129C48.3301 41.129 52.9479 39.3205 54.393 40.5961Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 38,
    width: 9,
    height: 7
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1692 38.3154L47.3271 43.5675L54.2832 44.6799L55.1253 39.4272L48.1692 38.3154Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1895 38.9873L47.4526 43.586L54.2557 44.6735L54.9932 40.0748L48.1895 38.9873Z",
    fill: "url(#paint19_radial_1570_1141)"
  })))))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4522 32.5337C51.7514 31.9581 52.3334 31.3754 55.3358 34.353C55.3358 34.353 52.7069 26.8456 50.4726 31.4984C50.1883 32.0913 50.201 32.6452 50.4522 32.5337Z",
    fill: "#D68607"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 33,
    width: 8,
    height: 8
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0443 33.417H55.1909V40.9238H48.0443V33.417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 33,
    width: 8,
    height: 8
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6211 33.6347C51.6211 33.6347 48.1316 35.018 48.1648 40.9012C48.1648 40.9012 52.8106 39.1909 54.6038 40.2242C54.6038 40.2242 55.8666 37.6195 54.5872 35.1417C54.2411 34.4705 53.4169 33.0483 51.6211 33.6347Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 33,
    width: 8,
    height: 8
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6212 33.6338C51.6212 33.6338 48.1318 35.0171 48.1649 40.9002C48.1649 40.9002 52.8108 39.1899 54.6039 40.2232C54.6039 40.2232 55.8668 37.6186 54.5874 35.1407C54.2412 34.4695 53.417 33.0473 51.6212 33.6338Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 31,
    width: 12,
    height: 12
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3242 31.8398L46.9039 40.7032L55.6742 42.1049L57.0938 33.2429L48.3242 31.8398Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3076 32.3018L46.9594 40.7137L55.0144 42.0014L56.3626 33.5894L48.3076 32.3018Z",
    fill: "url(#paint20_radial_1570_1141)"
  })))))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7028 29.6471C51.9176 29.591 52.1509 29.5846 52.4014 29.628C53.7337 29.8772 54.8213 31.4243 55.7233 34.3579C55.7462 34.4332 55.699 34.5154 55.6117 34.5543C55.5996 34.5587 55.5888 34.5626 55.5767 34.5664C55.4976 34.5868 55.4001 34.5728 55.365 34.5128C53.6241 31.5066 52.4142 31.3842 50.454 32.2161C50.3973 32.2403 50.3297 32.2148 50.2851 32.1816C50.2404 32.1472 50.2188 32.0969 50.2277 32.0452C50.4604 30.6294 50.9429 29.8447 51.7028 29.6471Z",
    fill: "#774104"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 42,
    width: 8,
    height: 3
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.192 42.0674H56.5299V44.3521H49.192V42.0674Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 42,
    width: 8,
    height: 3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3261 44.1141C49.3363 44.5501 51.5623 44.0975 52.9322 44.0063C54.3028 43.9158 56.4083 44.2084 56.3994 43.7737C56.3905 43.3389 56.567 41.6962 53.1292 42.1526C51.7663 42.3343 49.3171 43.6793 49.3261 44.1141Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 42,
    width: 8,
    height: 3
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3261 44.116C49.3363 44.552 51.5623 44.0994 52.9322 44.0083C54.3028 43.9178 56.4083 44.2104 56.3994 43.7756C56.3905 43.3409 56.567 41.6981 53.1292 42.1545C51.7663 42.3362 49.3171 43.6813 49.3261 44.116Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 41,
    width: 8,
    height: 5
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5565 41.2197L56.6279 44.5486L49.327 45.033L49.2556 41.7036L56.5565 41.2197Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5345 41.4316L56.5982 44.4188L49.3273 44.9001L49.2635 41.9136L56.5345 41.4316Z",
    fill: "url(#paint21_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 29,
    width: 6,
    height: 5
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5466 29.6631H55.2243V33.2533H50.5466V29.6631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 29,
    width: 6,
    height: 5
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6139 31.5369C50.6139 31.5369 51.8168 26.4996 55.2017 33.244C55.2017 33.244 52.358 28.987 50.6139 31.5369Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 29,
    width: 6,
    height: 5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6136 31.533C50.6136 31.533 51.8165 26.4957 55.2015 33.2401C55.2015 33.2401 52.3578 28.9831 50.6136 31.533Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 25,
    width: 8,
    height: 9
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1183 25.8662L49.7356 26.6171L50.6969 33.8689L56.0796 33.1174L55.1183 25.8662Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1179 28.9072L50.131 29.6027L50.6964 33.8693L55.6833 33.1738L55.1179 28.9072Z",
    fill: "url(#paint22_linear_1570_1141)"
  })))))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6183 40.2314C54.6075 40.2314 54.596 40.2295 54.5852 40.225C54.5195 40.1983 54.4864 40.1103 54.51 40.0268C55.2239 37.498 55.0652 35.6353 54.0433 34.4961C52.9214 33.3895 51.7402 33.415 50.4359 34.5701C49.9062 35.0845 49.437 35.9043 48.9819 36.8675C48.9455 36.944 48.4872 38.3031 48.4285 38.261C48.3693 38.2189 48.2086 38.0621 48.7364 36.6431C49.1215 35.6104 49.7315 34.8621 50.2938 34.3189C51.6873 33.0835 53.0024 33.0587 54.2084 34.2494C55.3164 35.4836 55.4968 37.4591 54.7458 40.1211C54.7261 40.19 54.6732 40.234 54.6183 40.2314Z",
    fill: "#C15C00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0434 41.8663C54.2155 41.6094 54.4469 41.1415 54.626 40.7297C54.6605 40.6519 54.635 40.5582 54.5712 40.5199C54.5068 40.4804 54.4284 40.5123 54.394 40.5894C54.1639 41.1185 53.7973 41.6706 53.5857 41.9211C53.7087 41.916 53.9197 41.879 54.0434 41.8663Z",
    fill: "#C15C00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9051 42.8422C56.3148 42.1334 55.4785 41.7324 54.4145 41.6897C54.238 41.6827 54.2048 41.668 54.0321 41.6763C54.0302 41.6769 53.8867 41.6827 53.8842 41.6846C52.4021 41.7464 50.4865 42.3737 48.191 43.5485C48.1215 43.5842 48.089 43.6773 48.1189 43.7557C48.1393 43.8093 48.1821 43.8418 48.2299 43.8475C48.2528 43.8494 48.2764 43.8456 48.2993 43.8341C50.5789 42.6663 52.4709 42.0479 53.9218 41.9963C53.9231 41.9963 53.9231 41.9963 53.9231 41.9963C55.1444 41.9523 56.0796 42.3112 56.7043 43.0609C56.7553 43.1227 56.8427 43.124 56.8987 43.0641C56.9536 43.0041 56.9568 42.9041 56.9051 42.8422Z",
    fill: "#C15C00"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9062 41.113C47.8724 41.0747 47.8641 41.0193 47.8852 40.9734C48.0413 40.624 48.4028 40.3346 48.9599 40.116C50.7263 39.418 52.8172 39.3446 55.1739 39.8973C55.3658 39.942 55.5596 39.991 55.754 40.0446C55.7974 40.0548 55.8305 40.0892 55.8445 40.1313C55.9587 40.4985 56.0141 40.8172 56.009 41.0786C56.0084 41.1193 55.9886 41.1563 55.9567 41.1793C55.9242 41.2029 55.8834 41.2099 55.8452 41.1978C55.4155 41.0588 54.9827 40.9409 54.5575 40.8472C52.3468 40.355 50.1545 40.4577 48.0401 41.1506C48.0152 41.1589 47.9884 41.1589 47.9629 41.1506C47.9419 41.1442 47.9221 41.1308 47.9062 41.113Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 33,
    height: 35
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0.432251 15.4648H32.3584V49.2454H0.432251V15.4648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 33,
    height: 35
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9711 25.2623C31.9239 25.1629 31.892 25.0724 31.8768 24.994C31.7091 24.5605 31.5312 24.1436 31.3426 23.7439C30.758 22.585 30.0969 21.5912 29.3428 20.7535L28.5619 19.9204C27.6491 19.0458 26.6444 18.3254 25.5442 17.7473C24.5829 17.2513 23.547 16.865 22.4238 16.5934C19.8051 15.752 17.4159 15.3848 15.2287 15.4862C12.0019 15.5984 9.25185 16.6718 6.95315 18.7117C5.7305 19.6775 4.6825 20.8281 3.79643 22.1795C3.09458 23.1389 2.48899 24.1748 1.97137 25.3031C1.09676 27.2684 0.614204 29.2796 0.514759 31.3533C0.483523 31.4687 0.477786 31.5802 0.498185 31.6854C0.507109 36.0514 1.97137 40.0776 4.89797 43.7348C7.86282 46.7538 11.6736 48.4966 16.3366 48.9926C16.5049 49.0149 16.6872 49.0334 16.8823 49.05C18.0846 49.1711 19.1612 49.1373 20.1244 48.9473C22.6718 48.4469 24.5402 47.6297 25.7418 46.4893C26.9058 45.3712 27.3355 44.0682 27.0397 42.565C26.9931 42.3279 26.9217 42.1099 26.8255 41.8957C28.9884 41.2519 30.496 40.135 31.361 38.5414C32.038 37.2435 32.2299 35.8506 31.9348 34.3475C31.7148 33.2275 31.1902 32.2356 30.3596 31.3565C32.2159 29.993 32.7501 27.9716 31.9711 25.2623Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 33,
    height: 35
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9709 25.2623C31.9237 25.1629 31.8918 25.0724 31.8765 24.994C31.7089 24.5605 31.531 24.1436 31.3423 23.7439C30.7578 22.585 30.0967 21.5912 29.3426 20.7535L28.5617 19.9204C27.6488 19.0458 26.6442 18.3254 25.5439 17.7473C24.5826 17.2513 23.5468 16.865 22.4235 16.5934C19.8048 15.752 17.4156 15.3848 15.2285 15.4862C12.0016 15.5984 9.25161 16.6718 6.95291 18.7117C5.73025 19.6775 4.68226 20.8281 3.79618 22.1795C3.09433 23.1389 2.48874 24.1748 1.97112 25.3031C1.09652 27.2684 0.613959 29.2796 0.514515 31.3533C0.483279 31.4687 0.477542 31.5802 0.497941 31.6854C0.506865 36.0514 1.97112 40.0776 4.89772 43.7348C7.86257 46.7538 11.6733 48.4966 16.3364 48.9926C16.5047 49.0149 16.687 49.0334 16.8821 49.05C18.0843 49.1711 19.161 49.1373 20.1242 48.9473C22.6715 48.4469 24.5399 47.6297 25.7415 46.4893C26.9056 45.3712 27.3352 44.0682 27.0394 42.565C26.9929 42.3279 26.9215 42.1099 26.8252 41.8957C28.9882 41.2519 30.4958 40.135 31.3608 38.5414C32.0378 37.2435 32.2297 35.8506 31.9345 34.3475C31.7146 33.2275 31.19 32.2356 30.3593 31.3565C32.2156 29.993 32.7498 27.9716 31.9709 25.2623Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 7,
    width: 50,
    height: 51
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.81812 17.5579L2.55089 57.0781L41.0448 47.0011L30.6758 7.48145L-7.81812 17.5579Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.80664 17.6016L2.52603 56.9816L40.6413 47.004L30.308 7.62402L-7.80664 17.6016Z",
    fill: "url(#paint23_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 1,
    width: 16,
    height: 17
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9447 1.12891H29.0696V17.7502H14.9447V1.12891Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask98_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 15,
    height: 17
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0575 3.73723C15.1434 5.01152 14.8349 6.5102 15.1211 8.24729C15.4902 10.6805 15.6649 12.1945 15.6476 12.8001C15.6508 13.7983 15.5112 14.6889 15.2288 15.4838C17.416 15.3824 19.8052 15.7496 22.4239 16.5911C23.5471 16.8626 24.583 17.2489 25.5443 17.7449C26.7083 16.6943 27.5772 15.538 28.1624 14.2599C29.0491 12.3602 29.2747 10.3031 28.8374 8.07517C28.3989 5.84723 27.4388 4.10504 25.9529 2.82183C24.2273 1.36713 22.1715 0.880108 19.7561 1.35374C18.1593 1.66738 16.9302 2.4572 16.0575 3.73723Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask99_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 15,
    height: 17
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0568 3.73527C15.1427 5.00956 14.8341 6.50824 15.1204 8.24534C15.4895 10.6785 15.6641 12.1925 15.6469 12.7981C15.6501 13.7964 15.5105 14.6869 15.2281 15.4818C17.4152 15.3805 19.8045 15.7477 22.4232 16.5891C23.5464 16.8607 24.5823 17.247 25.5436 17.7429C26.7076 16.6924 27.5764 15.536 28.1616 14.2579C29.0483 12.3583 29.274 10.3012 28.8367 8.07322C28.3981 5.84528 27.4381 4.10309 25.9522 2.81987C24.2266 1.36518 22.1707 0.878155 19.7554 1.35179C18.1585 1.66542 16.9295 2.45524 16.0568 3.73527Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask100_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: -3,
    width: 24,
    height: 25
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7064 2.0156L15.7622 21.283L33.4014 16.6652L28.3457 -2.60156L10.7064 2.0156Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8624 2.19652L15.8506 21.2051L33.1476 16.6772L28.16 -2.33203L10.8624 2.19652Z",
    fill: "url(#paint24_radial_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 50
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0.23877 0.780273H32.7042V49.4112H0.23877V0.780273Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1448 38.4211C30.3435 39.8981 28.9354 40.9645 26.9592 41.5944C26.2689 40.2193 24.6969 39.0515 22.1559 38.0239C19.1611 36.8529 15.8973 36.3697 12.4448 36.5903L11.8507 36.7076C11.7168 36.7337 11.6288 36.8644 11.6556 36.9989C11.6817 37.1315 11.8118 37.2194 11.9463 37.1927L12.5079 37.0805C15.8642 36.8682 19.0489 37.3399 21.973 38.4835C24.4648 39.4907 26.019 40.6681 26.5952 41.9832L26.601 41.9972C26.6902 42.1949 26.7546 42.3957 26.7973 42.6111C27.0772 44.0378 26.6768 45.247 25.5721 46.3091C24.41 47.4093 22.562 48.2151 20.0778 48.7027C19.1471 48.8857 18.08 48.9188 16.9039 48.8022C16.7126 48.7856 16.5341 48.7671 16.3627 48.7442C11.465 48.2259 7.67146 46.4863 5.08909 43.5743C2.21795 40.3405 0.75624 36.3302 0.742215 31.6365C0.728829 31.5683 0.732653 31.4969 0.754327 31.4204C0.759427 31.4032 0.762614 31.3847 0.763889 31.3637C0.861421 29.3276 1.34334 27.3228 2.19691 25.4053C2.71198 24.284 3.30227 23.2736 4.00476 22.313C4.86853 20.9947 5.9146 19.8466 7.11814 18.8961C8.80423 17.3987 10.7829 16.419 12.9988 15.9848C13.7159 15.8433 14.4681 15.7585 15.2439 15.7311C17.3883 15.633 19.7827 16.0021 22.3669 16.832C23.4532 17.0959 24.4827 17.4765 25.4108 17.9527L25.4319 17.9661C26.5136 18.5341 27.5068 19.2493 28.3821 20.0888L29.1591 20.9169C29.8973 21.7373 30.5392 22.6967 31.1187 23.8467C31.2965 24.2241 31.4763 24.6423 31.6344 25.0407C31.6535 25.1369 31.6918 25.2478 31.7332 25.3288C32.4618 27.8615 32.0207 29.726 30.3837 31.0265C28.2169 28.8852 24.1761 27.3234 18.3681 26.3813C15.6002 25.9 13.0918 26.0836 10.9111 26.9276C10.8499 26.9512 10.8008 26.9977 10.774 27.0589C10.7472 27.1194 10.7453 27.187 10.7695 27.2469C10.7938 27.31 10.8397 27.3579 10.9002 27.3853C10.9608 27.4114 11.0283 27.4127 11.0902 27.3891C13.1843 26.5789 15.6053 26.4036 18.2865 26.8689C24.1295 27.8168 28.1309 29.3837 30.1791 31.5256L30.1963 31.5428H30.1969C30.9918 32.3894 31.4814 33.322 31.6924 34.3936C31.9742 35.8279 31.7893 37.1837 31.1448 38.4211ZM15.3663 8.20778C15.0884 6.52232 15.381 5.10651 16.2632 3.87684C17.1015 2.64653 18.2597 1.90134 19.805 1.59791C22.1585 1.13574 24.1174 1.5979 25.792 3.01053C27.248 4.26697 28.1653 5.94031 28.5943 8.12363C29.0189 10.2846 28.7983 12.3143 27.9371 14.1572C27.3838 15.3671 26.5876 16.4438 25.5039 17.4472C24.5655 16.978 23.5533 16.6108 22.5008 16.3552C20.1543 15.6017 17.9461 15.2205 15.9298 15.2205C15.8112 15.2205 15.6914 15.2224 15.5741 15.2244C15.7915 14.49 15.8986 13.6772 15.8948 12.8077C15.9139 12.1792 15.7405 10.6748 15.3663 8.20778ZM30.7235 31.3873C32.4848 29.9664 32.9814 27.8755 32.196 25.1561C32.1558 25.0706 32.131 24.9986 32.108 24.903C31.9397 24.4676 31.7574 24.0399 31.5649 23.63C30.9625 22.4341 30.2951 21.4384 29.5238 20.5822L28.7339 19.7408C27.9027 18.9427 26.9713 18.2542 25.9654 17.6926C27.0236 16.6854 27.8377 15.5667 28.3865 14.3644C29.293 12.4265 29.5257 10.2948 29.0794 8.02865C28.6345 5.76374 27.6369 3.94888 26.114 2.63379C24.3399 1.13829 22.1846 0.626408 19.7087 1.11216C18.0538 1.43663 16.7566 2.27298 15.8571 3.59381C14.9105 4.91208 14.5816 6.49108 14.8774 8.28491C15.2414 10.6888 15.4173 12.2072 15.3988 12.8013C15.4039 13.6938 15.2866 14.5149 15.0488 15.2435C11.8571 15.3907 9.08026 16.4923 6.80004 18.5162C5.56209 19.4941 4.48413 20.6785 3.59678 22.0318C2.88091 23.0097 2.27532 24.0462 1.74495 25.2013C0.869708 27.1692 0.373123 29.2263 0.269854 31.314C0.236068 31.4491 0.229694 31.5868 0.251368 31.6945C0.262842 36.4679 1.76598 40.5751 4.71745 43.902C7.38524 46.9083 11.2852 48.7034 16.3053 49.2369C16.4774 49.2592 16.6635 49.2777 16.8586 49.2943C17.3316 49.3415 17.7893 49.3651 18.2291 49.3651C18.9233 49.3651 19.5742 49.3058 20.1728 49.1891C22.7513 48.683 24.6822 47.8345 25.9144 46.666C27.1339 45.4944 27.5954 44.0983 27.2837 42.5149C27.2518 42.3561 27.2104 42.2025 27.1562 42.0501C29.2331 41.3789 30.7215 40.2372 31.5815 38.6544C32.2821 37.3119 32.4829 35.847 32.1788 34.2992C31.9678 33.2276 31.4789 32.2485 30.7235 31.3873Z",
    fill: "#CC6600"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 2,
    width: 9,
    height: 9
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9752 2.0957H27.9078V10.8972H19.9752V2.0957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask103_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 2,
    width: 8,
    height: 9
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4891 4.50745C28.179 6.64806 28.3613 9.31904 26.8964 10.4722C25.4309 11.626 23.7097 9.93164 22.0198 7.79167C20.3305 5.65107 19.3125 3.87573 20.7774 2.72128C22.2429 1.56747 24.7998 2.36812 26.4891 4.50745Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask104_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 2,
    width: 8,
    height: 9
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4892 4.50355C28.1791 6.64415 28.3614 9.31513 26.8965 10.4683C25.431 11.6221 23.7099 9.92774 22.0199 7.78777C20.3307 5.64716 19.3126 3.87182 20.7775 2.71737C22.2431 1.56356 24.7999 2.36421 26.4892 4.50355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask105_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: -3,
    width: 20,
    height: 19
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1578 5.06267L22.4599 -2.73926L14.5177 8.12569L25.215 15.9283L33.1578 5.06267Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.148 5.18581L22.7345 -1.67969L15.7371 7.89248L25.1505 14.758L32.148 5.18581Z",
    fill: "url(#paint25_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 23,
    width: 5,
    height: 8
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73608 23.9355H11.8159V30.6442H7.73608V23.9355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask107_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 23,
    width: 5,
    height: 8
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M11.726 27.3906C11.6017 29.2373 10.7934 30.6869 9.92261 30.6276C9.05247 30.5684 7.6424 28.9059 7.76798 27.0591C7.89356 25.2124 9.50699 23.8807 10.3771 23.9394C11.2479 23.9986 11.8516 25.5432 11.726 27.3906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask108_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 23,
    width: 5,
    height: 8
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M11.727 27.3916C11.6027 29.2383 10.7944 30.6879 9.92359 30.6286C9.05345 30.5693 7.64338 28.9068 7.76896 27.0601C7.89454 25.2134 9.50796 23.8817 10.3781 23.9403C11.2489 23.9996 11.8526 25.5442 11.727 27.3916Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask109_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 23,
    width: 6,
    height: 8
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8413 30.8936L12.1995 23.8942L7.65379 23.666L7.29553 30.6647L11.8413 30.8936Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8371 30.8947L12.1928 23.9496L7.65343 23.7207L7.29773 30.6659L11.8371 30.8947Z",
    fill: "url(#paint26_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 33,
    width: 5,
    height: 8
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38855 33.417H12.622V40.3622H8.38855V33.417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask111_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 33,
    width: 5,
    height: 8
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3419 36.4564C12.8378 38.3465 12.5452 40.0606 11.6898 40.2844C10.8337 40.5088 9.03855 39.1644 8.54261 37.2736C8.04602 35.3835 9.03792 33.6637 9.89403 33.4393C10.7501 33.2155 11.8453 34.5657 12.3419 36.4564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask112_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 33,
    width: 5,
    height: 8
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.342 36.4554C12.838 38.3455 12.5454 40.0597 11.6899 40.2834C10.8338 40.5078 9.03868 39.1634 8.54273 37.2727C8.04614 35.3826 9.03804 33.6627 9.89415 33.4383C10.7503 33.2146 11.8454 34.5647 12.342 36.4554Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask113_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 32,
    width: 7,
    height: 9
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8258 40.7695L13.1809 33.2346L8.05883 32.9561L7.70312 40.4909L12.8258 40.7695Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6117 40.5913L12.9502 33.4205L8.37707 33.1719L8.03857 40.3427L12.6117 40.5913Z",
    fill: "url(#paint27_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 13,
    height: 11
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2009 17.4248H31.3912V27.7058H19.2009V17.4248Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask115_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 13,
    height: 11
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M25.795 19.1099C28.4807 20.8515 32.0186 24.9357 31.1746 27.3849C30.7035 28.7529 25.6261 25.2443 22.9398 23.5027C20.2542 21.7618 18.716 19.3662 19.5045 18.1531C20.2931 16.9394 23.1088 17.3684 25.795 19.1099Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask116_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 13,
    height: 11
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7948 19.1129C28.4804 20.8544 32.0184 24.9387 31.1744 27.3878C30.7033 28.7558 25.6259 25.2472 22.9396 23.5056C20.254 21.7647 18.7158 19.3691 19.5043 18.156C20.2928 16.9423 23.1085 17.3713 25.7948 19.1129Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask117_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 26,
    height: 26
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8188 23.9923L26.6549 10.4238L12.9137 21.7044L24.0789 35.2722L37.8188 23.9923Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.516 23.5917L26.4759 11.3906L14.0753 21.5709L24.116 33.772L36.516 23.5917Z",
    fill: "url(#paint28_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 27,
    width: 14,
    height: 11
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1805 27.9932H31.1982V37.8235H18.1805V27.9932Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask119_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 28,
    width: 14,
    height: 10
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9013 30.1732C29.6144 32.1219 32.3523 34.2644 30.6254 37.2152C29.768 38.6801 25.9712 36.5108 23.2582 34.5627C20.5451 32.614 17.3808 30.0342 18.3727 28.6573C19.3646 27.2803 24.1889 28.2238 26.9013 30.1732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask120_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 28,
    width: 14,
    height: 10
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9012 30.1741C29.6142 32.1229 32.3521 34.2654 30.6253 37.2162C29.7679 38.6811 25.9711 36.5118 23.2581 34.5637C20.545 32.615 17.3806 30.0352 18.3725 28.6582C19.3644 27.2813 24.1888 28.2248 26.9012 30.1741Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask121_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 20,
    width: 27,
    height: 26
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7398 31.1023L22.398 20.2227L11.9933 34.8608L27.3352 45.7404L37.7398 31.1023Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8554 31.2982L22.4495 21.791L13.3816 34.548L26.7875 44.0551L35.8554 31.2982Z",
    fill: "url(#paint29_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 38,
    width: 12,
    height: 7
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7324 38.043H26.1671V44.0243H15.7324V38.043Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask123_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 38,
    width: 12,
    height: 6
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8754 39.2423C24.6471 40.5879 26.4792 42.5328 25.9679 43.5821C25.4561 44.6333 23.2045 43.4183 20.4328 42.0726C17.6611 40.725 15.4185 39.7554 15.9304 38.7042C16.4417 37.6543 19.1031 37.8953 21.8754 39.2423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask124_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 38,
    width: 12,
    height: 6
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8752 39.2423C24.6469 40.5879 26.4789 42.5328 25.9677 43.5821C25.4558 44.6333 23.2043 43.4183 20.4326 42.0726C17.6609 40.725 15.4183 39.7554 15.9302 38.7042C16.4414 37.6543 19.1028 37.8953 21.8752 39.2423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask125_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 33,
    width: 18,
    height: 16
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1853 38.955L17.4796 33.3281L12.7133 43.3319L24.4184 48.9588L29.1853 38.955Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4898 39.161L17.6656 33.958L13.3959 42.9195L24.22 48.1218L28.4898 39.161Z",
    fill: "url(#paint30_linear_1570_1141)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 11,
    height: 8
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3092 16.6064H14.9166V23.5459H4.3092V16.6064Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask127_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 11,
    height: 8
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.853 16.9387C15.1609 17.5099 12.4708 18.0644 9.75517 19.5204C7.04085 20.977 4.70454 24.0337 4.39664 23.4619C4.08939 22.8907 6.40083 19.6434 9.11452 18.1875C11.8295 16.7309 14.5457 16.3662 14.853 16.9387Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask128_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 11,
    height: 8
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8531 16.9377C15.161 17.5089 12.4709 18.0635 9.7553 19.5194C7.04097 20.976 4.70466 24.0327 4.39677 23.4609C4.08951 22.8897 6.40096 19.6425 9.11464 18.1865C11.8296 16.7299 14.5458 16.3653 14.8531 16.9377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_1570_1141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask129_1570_1141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 12,
    width: 18,
    height: 17
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3069 12.2402L1.22437 17.6529L5.94352 28.1647L18.0267 22.7527L13.3069 12.2402Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_1570_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1632 12.6211L1.70154 17.7546L6.08411 27.5161L17.5451 22.3826L13.1632 12.6211Z",
    fill: "url(#paint31_linear_1570_1141)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8652 42.1123) rotate(179.633) scale(20.786 20.7617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCCF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCCA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCC629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBD13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#FCB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FCB60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FCB50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FCB40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FCB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FDB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FDB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#FEAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FFAA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA80B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1570_1141",
    x1: 16.3547,
    y1: 56.8293,
    x2: 35.5733,
    y2: 44.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FDF1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDF1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FDF0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#FDEFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FDEEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDEDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FDECB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FDEBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDEAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FDE9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FDE8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FDE7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FDE6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FDE59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FDE59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FDE499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCE396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCE293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCE090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FCDF8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCDE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCDD89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCDC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCDB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCDA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCD97E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FCD778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCD676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCD673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCD36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCD062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCCE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCCD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCCC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCCB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCCA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCC952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCC84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCC74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCC649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCC647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCC544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCC33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FBC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FBC036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FBBE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBBD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBBC2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBBB2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FBBA29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FBB926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FBB823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#FBB821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FBB71E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBB61B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FBB518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FBB416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FBB313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBB210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FBB10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB00B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1570_1141",
    x1: 40.3417,
    y1: 58.7445,
    x2: 41.6891,
    y2: 43.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDF8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#FCDF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FCDE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117187,
    stopColor: "#FCDE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FCDD89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FCDD88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FCDD87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FCDD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FCDC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FCDC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FCDC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429687,
    stopColor: "#FCDB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FCDB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FCDA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FCDA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585937,
    stopColor: "#FCDA7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FCD97E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FCD97D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FCD97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FCD87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FCD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#FCD879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FCD779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#FCD778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FCD777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FCD676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FCD675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FCD574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FCD573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FCD572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FCD571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FCD470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FCD46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FCD46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FCD36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FCD36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FCD36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FCD26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FCD26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FCD269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FCD168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FCD166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FCD164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FCD063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FCD062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FCCF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FCCF60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FCCF60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FCCE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#FCCE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FCCE5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FCCD5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCCD5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCCD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCCC59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCCC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCCC57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCCB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCCA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCCA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCC952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCC950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#FCC94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCC84E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCC84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCC84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCC74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCC649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCC648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FCC648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCC547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCC546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCC545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FCC544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCC443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCC442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FCC340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCC33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCC23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCC23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCC23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCC23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCC13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FBC13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FBC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FBC038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FBC037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FBBF36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FBBF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FBBF34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FBBE33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FBBE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FBBE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FBBD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FBBD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FBBD2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FBBD2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FBBC2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBBC2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FBBB2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#FBBB2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FBBB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FBBA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FBBA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FBBA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FBB925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FBB924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FBB924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FBB923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FBB822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBB821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBB820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FBB71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FBB71E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FBB61D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FBB61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#FBB61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FBB61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FBB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FBB518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FBB417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBB416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FBB315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FBB314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FBB313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBB212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FBB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FBB10E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBB10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FBB10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FBB10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB00B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1570_1141",
    x1: 44.4355,
    y1: 20.3566,
    x2: 39.6118,
    y2: 46.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDF2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDF1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDF1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDF1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FDF0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDF0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDEFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDEFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDEEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDEEB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDEEB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#FDEDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDEDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDEDB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDECB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDECAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDEBAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDEBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FDEBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDEAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FDEAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FDE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FDE9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FDE9A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FDE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FDE8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FDE8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#FDE7A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FDE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FDE69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FDE69B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FDE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDE599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FDE597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDE495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCE494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCE393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FCE392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCE290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCE28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCE28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#FCE18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCE18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCE08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCE089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FCE088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCE087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCDF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCDF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#FCDF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCDE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCDE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCDE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCDD7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCDD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCDC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCDC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#FCDB7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCDB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCDB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCDA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCDA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCD972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCD971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FCD970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCD86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCD76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCD66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCD669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCD668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FCD667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCD566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCD463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCD462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCD35F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCD35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FCD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCD25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCD25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCD159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCD158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCD157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCD156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCD055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FCD054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FCCE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCCD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCCD4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCCD49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCCC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCCC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCCB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCCB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCCA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCCA42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCCA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCC83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#FCC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCC83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FBC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FBC737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FBC636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBC635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FBC533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FBC532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FBC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FBC42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FBC42E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FBC42D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FBC32C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBC32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FBC32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FBC228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBC123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBBF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBBF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBBE1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBBE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBBD19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBBD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#FBBC15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBBA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBB90D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3045 37.4615) rotate(-164.972) scale(3.06562 2.75288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FD9303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FD9403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FD9403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FD9503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FD9603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FD9603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FD9703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FD9803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FD9803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FD9903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FD9A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FD9A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FD9B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FD9B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FD9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FD9C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FD9C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FD9D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FD9D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FD9E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FD9F02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCA002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCA102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCA102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCA202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FCA202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCA302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FCA302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCA402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCA402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCA502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCA502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCA602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCA602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCA702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCA802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCA802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCA902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCAA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCAA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCAB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCAC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCAD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCAD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCAE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCAF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCAF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCB001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCB101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCB101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCB101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCB301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCB301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCB301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCB401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCB401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCB501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCB501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCB601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCB601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FCB701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FCB701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FCB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FCB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FCB901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FCBA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FCBA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBBA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBB01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBBB01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBC01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBC001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FBC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FBC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FBC500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#FBC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FBC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#FBC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FBC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FBC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3862 49.2629) rotate(172.582) scale(9.03291 8.70326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#260000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#270000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#270000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#280000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#280000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#290000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#2A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#2B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#2B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#2C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#2F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#2F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#330000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#330000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#330000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#340000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#350000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#360000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#360000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#370000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#380000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#390000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#3A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#3B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#3E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#3F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#410000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#420000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#430000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#430000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#440000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#440000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#450000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#460000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#460000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#470000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#470000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#480000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#480000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#490000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#4A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#4A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#4B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#4C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#4D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#4E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#4E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#500000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#500000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#510000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#520000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#520000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#530000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#530000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#540000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#550000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#560000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#570000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#570000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#580000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#590000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#5A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#5B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#5C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#5D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#5E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#5F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#610000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#620000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#630000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#650000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#670000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#680000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#690000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#6A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#6B0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#6C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#6C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#6E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#6F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#710000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#720000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#730000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#740000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#750000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#750000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1570_1141",
    x1: 43.8615,
    y1: 37.5529,
    x2: 40.7587,
    y2: 50.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCD657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCD657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#FCD555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCD251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCD14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FCD14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCD04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCD04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCD04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#FCCF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCCE49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCCE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCC45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FBCB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBCB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FBCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FBCA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBCA40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FBC93F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FBC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FBC83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FBC83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FBC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FBC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FBC63B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBC63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FBC639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#FBC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FBC537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FBC436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FBC436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FBC334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBC334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FBC333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#FBC232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FBC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FBC130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FBC12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FBC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FBC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBBF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FBBF2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBBE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FBBE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBBD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FBBD28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBBC27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBBC26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBBB25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBBB24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBBA23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBBA23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBB922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBB921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBB821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBB820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FAB81F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#FAB71E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FAB71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FAB61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FAB61B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FAB51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FAB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAB418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FAB417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FAB417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FAB316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FAB315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FAB214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FAB213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FAB112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FAB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FAB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FAAF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FAAF0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAAE0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FAAE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FAAE0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FAAD0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FAAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FAAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FAAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAD0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1570_1141",
    x1: 37.6083,
    y1: 57.7941,
    x2: 39.3946,
    y2: 50.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#BF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#C02A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#C22A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#C22A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#C32B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#C42B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#C52B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#C52C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C62C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#C72C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#C82C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#C82D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#C92D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#CA2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#CB2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#CC2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#CD2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#CF2F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#D02F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#D02F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#D1302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#D13030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D23030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#D33130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D33130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#D43131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#D53231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#D63231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#D73232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#D73332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#D83332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#D93332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#DA3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#DC3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DC3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#DD3534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE3534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DF3534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DF3634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E03635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E13635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E13736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#E23736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E33736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#E43837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E53837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#E63937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#E73937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#E83938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#E93938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EA3938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#EB3A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EB3A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EC3A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ED3B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#EE3B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EE3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EF3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#F03C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F03C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F13D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F23D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#F33D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F43E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F63E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F63F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F73F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F83F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F83F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FA403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FB403F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#FB413F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC413F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FD423F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FE4240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FF4240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FF4240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FF4240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1570_1141",
    x1: 41.4095,
    y1: 43.3273,
    x2: 39.4318,
    y2: 52.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#C7E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#C8E0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#C8E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#CAE1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#CBE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#CCE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CDE3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#CEE3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#CFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#D0E4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#D1E5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#D1E5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#D1E6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#D2E7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#D3E7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#D4E8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#D5E8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#D6E9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#D7E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#D8EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#D9EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#D9EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#DBEBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#DDECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DEEDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#DEEDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#E0EDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E1EEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#E2EEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#E3EFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#E3EFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#E3F0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#E4F0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#E5F1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E6F1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#E7F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#E8F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#E9F3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EAF4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EBF4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EBF5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#ECF5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#EDF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#EEF6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EFF6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#EFF6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#F0F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F0F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F1F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F1F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F3F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F3F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#F4F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F4F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#F5F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#F6FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F6FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F7FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F8FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F9FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1570_1141",
    x1: 38.3372,
    y1: 51.6172,
    x2: 35.8428,
    y2: 53.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FD9A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FD996D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FC976C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FC966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FC956B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FC946A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FC936A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#FB9169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FB9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FB8F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FB8E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FB8D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FA8C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FA8B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FA8A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FA8964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FA8763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FA8662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F98561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F98361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F98260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F98160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F9805F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#F97F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F87E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F87D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#F87C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F87B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#F8795C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F8785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#F8775A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#F77659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#F77559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F77358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#F77257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#F77257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#F67056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F66F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#F66E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#F66D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#F66B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F56A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#F56952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F56851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#F56751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F56650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#F5654F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#F4644F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#F4634E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F4624E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#F4604D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#F45F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#F45E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F35D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#F35C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F35A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#F35949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F35848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#F35747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#F25647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#F25546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F25446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#F25245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F25144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#F15044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F14F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#F14E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F14C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#F14B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F04A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#F04940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#F0483F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#F0473E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F0463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#F0443D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#F0433C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#EF423B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EF413B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EF403A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#EF3E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EF3D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EE3C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EE3B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#EE3A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#EE3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EE3836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#ED3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#ED3635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#ED3534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#ED3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#ED3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1570_1141",
    x1: 41.0885,
    y1: 53.5408,
    x2: 39.1535,
    y2: 55.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FD9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FD9B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FD9B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FD9A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FD996D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FC976C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FC966C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FC956B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FC946A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FB926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FB9169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FB9068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FB8F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FB8D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FB8C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FA8A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FA8964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FA8863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FA8763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#F98662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#F98461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#F98361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F98260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#F9815F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F97F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#F87E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F87D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F87C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F87A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F8795B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F7785A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F7775A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F77559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F77458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F77357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#F77257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#F67056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#F66F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F66D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#F66C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#F66B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#F56A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F56952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#F56751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#F56651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#F56550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F4644F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#F4624E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#F4604E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#F4604D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F45F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#F35D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F35C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#F35B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F35A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#F35848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#F35748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#F25647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F25446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#F25345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#F25245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#F15044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F14F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#F14E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F14D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#F14C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F14A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#F04940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#F0483F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#F0473E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F0453D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#EF443C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#EF433C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#EF423B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EF403A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#EF3F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#EF3D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#EE3C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EE3B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#EE3A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#EE3836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#EE3736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ED3635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#ED3534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ED3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1570_1141",
    x1: 30.8396,
    y1: 36.7287,
    x2: 30.6639,
    y2: 41.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#FDE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117187,
    stopColor: "#FDE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FCE27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FCE27E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FCE17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FCE17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FCE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FCE079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#FCE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FCDF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FCDF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FCDE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FCDE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FCDD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FCDD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FCDC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FCDC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FCDB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FCDB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FCDA69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FCDA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FCD965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FCD863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FCD862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FCD761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FCD760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FCD75F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FCD65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FCD65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FCD55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FCD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FCD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FCD456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FCD355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FCD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FCD253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FCD252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FCD250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FCD14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCD14D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCD04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCD04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCCF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCCD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCCD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCCC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCCB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCCB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCCB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FCCA3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCCA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCC939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCC835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCC733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FBC631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FBC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FBC122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FBBF1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FBBE1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FBBC15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1570_1141",
    x1: 54.2312,
    y1: 44.046,
    x2: 52.7917,
    y2: 47.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FDEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDEFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDEEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDEDA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDEC9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FDEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDEA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDEA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDE88D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#FDE78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDE688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDE486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDE484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDE382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FDE380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FCE27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCE17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCE17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCDF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCDF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCDE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCDE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#FCDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCDD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCDC6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCDC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FCDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCDA69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCDA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FCD964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCD761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD75F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FCD65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#FCD457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FCD251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCD04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#FCD04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCCF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCCE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCCD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCCC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCCB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCCB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCCA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FBC42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FBC226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FBBF1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBBD19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FBB90D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9997 34.788) rotate(177.559) scale(4.28107 4.08233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FDDA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDDA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC21F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBC11D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBBB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FAB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#F9B60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F9B50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#F8B30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#F8B20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#F8B10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#F7B00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#F7AF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#F6AD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#F6AD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F5AC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#F4AA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#F4A80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#F3A70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F3A60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#F3A50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F2A40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#F2A30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F1A10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#F0A00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#EF9F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#EF9D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#EE9C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#EE9B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#ED9A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#ED990B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED990B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0155 35.5088) rotate(177.559) scale(5.15619 5.15018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FBFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FAFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#F9FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#F7FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#F6FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F6FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F4FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#F3FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F3FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F1FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#F0F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#EFF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EEF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EDF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#ECF8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#EBF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#EAF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#E9F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E9F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#E7F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#E6F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#E5F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#E4F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E3F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E3F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#E2F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#E0F3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#DFF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#DFF2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#DEF2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#DDF2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#DCF2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#DBF1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#DAF1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#D9F1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D8F0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#D8F0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D7F0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#D6F0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#D5EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#D5EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#D4EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#D3EEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#D3EEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#D3EEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#D2EEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#D1EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#D0EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CFEDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#CEECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CEECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#CDECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CCECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#CBEBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CAEBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#C9EBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C9EBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#C8EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#C7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#C6EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#C6E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C5E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#C4E9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C4E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#C3E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C1E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#C1E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C0E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#BFE7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#BEE7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#BEE6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#BDE6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#BCE6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#BBE5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#BAE5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#BAE5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#B9E4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#B8E4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#B8E4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#B7E3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#B6E3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#B5E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#B4E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#B2E2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#B1E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#B0E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0E1F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0479 35.6714) rotate(177.559) scale(2.801 2.79773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#60DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#60DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#60D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#60D8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#5FD8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#5FD7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#5FD7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#5FD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#5FD5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#5FD4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#5FD4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#5FD3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#5FD2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#5FD2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#5ED1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#5ED0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#5ED0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#5ED0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#5ECFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#5ECEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#5ECEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#5ECDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#5ECDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#5ECCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#5ECCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#5DCBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#5DCBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#5DCAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#5DCAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#5DC9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#5DC9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#5DC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#5DC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#5DC7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#5DC6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#5DC5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#5CC5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#5CC4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#5CC3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#5CC2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#5CC1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#5BC0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#5BBFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#5BBEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#5BBDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#5BBCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#5BBBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#5BBAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#5BB9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#5AB8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#5AB8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#5AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#5AB6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#5AB5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#5AB4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#59B3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#59B2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#59B1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#59B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#59AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#58ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#58ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#58ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#58ABF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#58A9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#57A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#57A7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#57A6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#57A4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#57A3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#56A1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#56A0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#569FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#569EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#559CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#559BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#559AEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#5598EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#5597EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#5495EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#5494EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#5492ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#5390ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#538EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#538DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#538BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#528AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#5288EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#5286EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#5285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#5283EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#5181EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#517FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#517DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#507BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#5079E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#5077E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4F75E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#4F73E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#4F71E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#4E6FE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#4E6DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#4E6BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#4D69E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#4C66E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4C64E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#4C62E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4B5FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#4B5DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4B5BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#4A59E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#4A56E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#4A54DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4951DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#484EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#484BDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#4849DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4746DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#4744DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4741DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#463EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#463CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#4539D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4536D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#4432D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#442FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#432CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#4329D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#4227D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4226D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1570_1141",
    x1: 40.8671,
    y1: 20.862,
    x2: 41.4465,
    y2: 24.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0874D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#B0874D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#B0874D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#B0864C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#AF854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#AE854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#AE844A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#AD8349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#AC8248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#AB8147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#AB8046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#AA8046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#A97F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#A97D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#A77C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#A67B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#A67A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A57A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#A4793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#A4783D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#A3773C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#A2763B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#A1753B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#A0743A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#A07338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#9F7237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#9F7136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#9E7136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#9D7035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#9C6F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#9B6D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#9A6C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#9A6C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#996B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#986A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#97692D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#96682C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#95672C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#95662B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#94652A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#946429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#936328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#926227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#926226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#916125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#906024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#8F5F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#8E5D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#8E5D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#8D5C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#8C5B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#8B5A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#8A591D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#89581C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#89571B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#88561A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#885519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#875418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#865317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#855316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#845215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#845114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#835013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#824F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#814D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#804C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#7F4B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#7F4A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#7E490D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#7D480C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#7C470B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#7B470A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#7B4609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#7A4508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#794407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#794307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#784206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#784205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#774104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1570_1141",
    x1: 31.7419,
    y1: 29.9285,
    x2: 29.0875,
    y2: 34.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FDF0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FDF0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FDEFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FDEFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDEEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FDED9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FDED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FDEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FDEC9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FDEB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FDEA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FDEA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FDE990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FDE88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FDE78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FDE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FDE688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FDE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FDE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDE384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FDE382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCE280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCE27E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCE17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FCDF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCDF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCDF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCDD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCDC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCDC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCDA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCD864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCD862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD65E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCD65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCD252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCD251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCD14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCD04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCD04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCCD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCCC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCCC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCCB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FCC835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FBC733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#FBC226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBBF1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBBE1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FBBB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBBA0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1570_1141",
    x1: 57.2764,
    y1: 40.4444,
    x2: 57.3777,
    y2: 42.0383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117187,
    stopColor: "#FDE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351563,
    stopColor: "#FDE88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE78D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE78D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#FDE78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDE689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDE588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FDE588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDE484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDE484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDE483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDE382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDE382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDE381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDE380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FCE280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FCE27F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FCE27E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FCE17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FCE17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FCE17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FCE07B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FCE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FCE079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FCE079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FCE078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FCDF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FCDF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FCDF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FCDF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FCDE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FCDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FCDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCDD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCDD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCDD6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCDD6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCDC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCDC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCDC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCDC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCDB69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FCDA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCDA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCDA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCD965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FCD864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCD862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FCD861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD75F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FCD75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD65E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCD65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCD65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCD55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCD457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCD456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCD253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCD252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCD251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCD251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCD150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCD14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCD14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCD04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCD04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCD04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCD04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCCF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FCCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCCD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCCD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCCC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCCC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FCCB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCB3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCCA3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCCA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCCA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCC835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCC733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FBC631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBC631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FBC630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FBC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FBC52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FBC42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FBBF1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBBE1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBC15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4696 41.7987) rotate(9.08557) scale(3.95372 3.94933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCCF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCCA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCC629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBD13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#FCB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FCB60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FCB50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FCB40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FCB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FDB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FDB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#FEAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FFAA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA80B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4856 37.3181) rotate(9.08508) scale(4.67663 4.4398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCCF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCCA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCC629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBD13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#FCB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FCB60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FCB50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FCB40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FCB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FCB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FDB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FDB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#FDAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FEAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FEAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#FEAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FEAB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FFAA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FFA90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA80B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8478 43.1802) rotate(176.21) scale(2.58998 2.87033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FD9303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FD9303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FD9403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FD9404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FD9504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FD9504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FD9604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FD9704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FD9804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FD9904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FD9905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FD9905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FD9A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FD9A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FD9B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FD9B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FC9C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FC9D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FC9E05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FC9F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCA006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCA006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCA106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCA106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCA206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCA206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCA306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCA307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCA407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCA407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCA507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCA607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCA607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCA807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCA808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCA908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCA908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCAA08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCAA08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCAB08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCAC08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCAC08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FCAD09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCAD09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FCAE09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FCAE09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FCAF09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBB109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBB109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBB20A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#FBB30A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBB40A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBB40A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBB50A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBB50A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FBB60A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#FBB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1570_1141",
    x1: 52.4945,
    y1: 29.273,
    x2: 53.0893,
    y2: 33.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0874D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#B0864D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#AF864C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#AE854B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#AD844A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AD8349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#AC8248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#AC8247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#AB8147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#AB8046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#AA7F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#A97E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#A87D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#A77C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#A77C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#A67B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#A57A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A4793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#A3783D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#A3773C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#A2763B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#A1753A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#A17539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#A07439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#A07338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#9F7237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#9E7136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#9D7035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#9C6F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#9C6F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#9B6E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#9B6D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#9A6C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#996B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#986A2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#97692E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#97682D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#96672C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#95662B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#95662A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#946529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#946428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#936327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#926227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#916126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#906025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#905F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#8F5F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#8F5E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8E5D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#8D5C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#8D5B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#8C5A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#8B5A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#8A591D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#89581C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#89571B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#885619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#885519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#875418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#865317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#855316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#845215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#845115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#835014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#834F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#824E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#824E11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#804C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#7F4B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#7F4B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7E4A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#7D490C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#7D480C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#7C470A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#7B4609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#7A4508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#7A4507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#794407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#784306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#784205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#774104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#774104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774104"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5791 32.9665) rotate(-14.6696) scale(16.6848 16.6678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FDDA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDDA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC21F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBC11D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBBB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FBB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FBB60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBB50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FBB40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FBB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FBB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FBAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FBAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FBAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#FBAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAB0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1570_1141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2336 8.26329) rotate(-14.6696) scale(8.12531 8.11704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDE26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDE16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDE16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDE06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDE069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDE068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDDF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#FDDE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDDE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FDDD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDDD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDDC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDDB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FDDA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDDA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDDA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDD959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDD958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FDD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCD957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCD856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCD753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCD651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCD650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FCD550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FCD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCD44E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCD44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCD34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCD349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCD248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCD247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCD144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCD043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCD041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCCF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCCF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCCE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCCD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCCD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCCC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCCC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCCB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCCA35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCCA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCC932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCC931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCC82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCC82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCC72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCC72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCC62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCC62A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCC528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCC527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCC426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBC323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC21F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBC11E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBC11D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBC01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBC01B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBBB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FBB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FBB70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FBB60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBB50B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FBB40B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBB30B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#FBB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBB20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FBB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBB10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FBAE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FBAD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FBAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#FBAC0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAB0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1570_1141",
    x1: 27.4021,
    y1: 1.72436,
    x2: 20.415,
    y2: 11.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FDFBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FDFABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FDF9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FDF8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDF8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FDF7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FDF6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FDF6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FDF5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FDF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDF3A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FDF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FDF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FDF1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FDF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FDF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FDEF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDEF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FDEE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FDED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FDED95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FDEC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCE98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCE98A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCE888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FCE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCE580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCE37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCE27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCDF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCDE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCDD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCDD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCDD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCDA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FCD75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FCD350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FCD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FCD14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FCCE45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FCCC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FCCA3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBC935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBC52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FBC427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FBC324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FBBE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBD16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1570_1141",
    x1: 12.0175,
    y1: 27.3744,
    x2: 7.47817,
    y2: 27.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDFBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDFBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDFABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDFAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDFAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDF9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#FDF8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDF8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#FDF8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDF8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDF7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDF7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDF6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#FDF6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#FDF5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDF5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#FDF5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#FDF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDF4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDF3A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#FDF3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#FDF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDF1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDF1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FDF1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#FDEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDEF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDEF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDEE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FDEE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#FDEE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDEE98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDEC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDEC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FDEC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCEB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCEA8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCE98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCE98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCE889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCE889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCE888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCE685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FCE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCE582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FCE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCE480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCE480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FCE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCE37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FCE278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCDF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCDF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCDE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCDE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCDD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FCDB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCDA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCD75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#FCD350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCD24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCD14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCD047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FCCD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FCCC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FCCC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FCCB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FCCB3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FCCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBC835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBC733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1570_1141",
    x1: 12.7826,
    y1: 36.9719,
    x2: 8.20764,
    y2: 36.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#FDF9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#FDF8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#FDF8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#FDF8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#FDF7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#FDF7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#FDF7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FDF6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#FDF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#FDF6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FDF5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#FDF5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#FDF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#FDF4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#FDF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FDF3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#FDF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FDF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#FDF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FDF2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#FDF1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FDF1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#FDF1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#FDEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FDEF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#FDEF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#FDEF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#FDEE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FDEE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#FDEE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#FDEC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#FDEC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDEC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#FDEC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FCEB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#FCEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FCEA8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FCE98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FCE98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCE88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FCE889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCE888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FCE685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FCE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FCE582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FCE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FCE580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FCE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FCE47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCE27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCE278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FCE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCE074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCDF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FCDF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FCDE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCDD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCDD6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCDD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCDD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCDC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCDB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCDB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FCDA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCDA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCD85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCD555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCD350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCD04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FCCD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FCCC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#FBC935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1570_1141",
    x1: 31.6097,
    y1: 17.6291,
    x2: 19.2208,
    y2: 27.8239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDFBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FDFABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FDFAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FDF9B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FDF8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FDF6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FDF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FDF5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FDF4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FDF3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FDF3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FDF1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FDF1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FDF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FDEF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FDEE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FDEE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FDEC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FDEC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCEA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCE98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCE889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FCE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCE582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCE481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCE37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCE072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCDD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FCDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FCD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCD14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCCE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FBC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBC935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1570_1141",
    x1: 29.0789,
    y1: 26.4928,
    x2: 20.0253,
    y2: 39.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#FDFBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDFBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#FDFABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FDFAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#FDF9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FDF8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FDF8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FDF8B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FDF7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FDF5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FDF5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FDF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FDF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FDF3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDF3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FDF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FDF1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FDF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FDF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FDEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#FDEF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FDEE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FDEE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FDED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FDEC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FDEC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FDEC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCEB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCEA8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCE98A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#FCE888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCE887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCE785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FCE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCE580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCE47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FCE37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCE075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCE074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCE073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#FCDF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCDF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCDE70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCDD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FCDC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FCDA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCDA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCD353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCD350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCD14D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#FCD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCD14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#FCD047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCCD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCCC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FCCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FCCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#FBCA37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#FBC935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#FBC72F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBC427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FBC427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBC324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBC224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBC11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBC01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBB10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1570_1141",
    x1: 23.1225,
    y1: 36.581,
    x2: 18.8222,
    y2: 45.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#FDFBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FDFBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#FDFABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDF9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#FDF9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FDF8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#FDF8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDF7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FDF7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FDF6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FDF5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FDF5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FDF3A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FDF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FDF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#FDF2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FDF1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FDF1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FDF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#FDEF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FDEF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FDEE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FDEE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FDEE98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FDED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FDEC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#FCEB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCEB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FCEA8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCE888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FCE787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCE786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCE685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCE683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCE582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCE580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCE47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FCE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#FCE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FCE27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FCE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#FCE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FCE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FCE074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FCE072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FCDF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FCDF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FCDE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FCDE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCDD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#FCDC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FCDC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FCDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FCDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FCDA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FCD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FCD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FCD85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FCD75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#FCD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#FCD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FCD557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#FCD454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FCD453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#FCD352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#FCD350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCD24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#FCD24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCD14D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#FCD14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#FCD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#FCCF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FCCF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#FCCF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FCCE43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#FCCE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FCCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#FCCC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FCCC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FCCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FCCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FCCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCCA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FCCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBCA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FBC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FBC937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#FBC935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FBC834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#FBC732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FBC730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#FBC630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#FBC62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#FBC62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#FBC52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#FBC429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#FBC327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FBC325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FBC324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBC222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#FBC121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#FBC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#FBBF1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FBBE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#FBBD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FBBD15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FBBC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FBBC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FBBA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#FBBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBA0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1570_1141",
    x1: 7.38426,
    y1: 15.2093,
    x2: 11.7582,
    y2: 24.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FDFCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#FDFCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#FDFBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#FDFABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FDF9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#FDF7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#FDF6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#FDF4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#FDF2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#FDF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#FDEE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#FDED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FCEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#FCEA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#FCE889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#FCE685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FCE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#FCE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#FCE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#FCE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FCDF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#FCDE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#FCDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#FCDC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FCDA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#FCD960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#FCD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FCD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FCD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#FCD34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FCD14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FCD049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FCCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCCE44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCCD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FCCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FBCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FBCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#FBC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#FBC833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#FBC731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#FBC62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#FBC62C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FBC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FBC428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FBC326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FBC223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBC221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FBBF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FBBF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FBBE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FBBD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FBBD16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBBC15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FBBC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#FBBB13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FBBB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#FBBA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FBBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#FBBA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBBA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#FBBA0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBB90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBB90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB90B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceEffective);
export default __webpack_public_path__ + "static/media/price_effective.cce3a7e64a63de2ebf8432dc86424a16.svg";
export { ForwardRef as ReactComponent };